import React, { useState, useEffect, useRef, Suspense } from 'react'
import { createPortal } from 'react-dom'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal, Form } from 'react-bootstrap'
import axios from 'axios'
import Card from '../../../components/Card'
import LoaderModal from '../../../components/loaderModal'
import CustomToggle from '../../../components/dropdowns'
import ShareOffcanvas from '../../../components/share-offcanvas'
import { Link, useNavigate, useLocation, Route } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { handleImageUpload } from "../../../api/uploads";
import { FEEDS_LIST, FOLLOWER_LIST, FOLLOWING_LIST, PROFILE_COVER_PIC_UPDATE, PROFILE_DETAILS, PROFILE_GALLERY, DAILY_REPORTS_LIST, GRADE_TRANSACTIONS, GRADE_TRANSACTION_PAY, QUICKBOOK_CARD_SAVE, QUICKBOOK_CARD_LIST, GAME_LIST, TEACHERS_GET_ASSIGNED_GAMES_API, STUDENT_ATTENDANCE_LIST_API, SEND_PARENT_INVITATION, PARENT_INVITATION_LIST, ACCEPTED_PARENT_LIST, TOGGLE_PARENT_ACCESS } from "../../../api/constants";
import { isStudentLoginProfile, isParentLoginProfile, isActingAsParent, isSelfStudentProfileView, getEffectiveStudentId, getParentChildren, getSelectedChildProfile, setStoredParentStudentId } from '../../../utilities/teacherModulePermissions';
import { fetchAllGameCategories } from '../../../utilities/gameCategories';
import Moment from 'moment';
import ReactFsLightbox from 'fslightbox-react';
import Swal from 'sweetalert2'
import { InView } from "react-intersection-observer";

// images
import img1 from '../../../assets/images/page-img/profile-bg1.jpg'
import g1 from '../../../assets/images/page-img/g1.jpg'
import g2 from '../../../assets/images/page-img/g2.jpg'
import g3 from '../../../assets/images/page-img/g3.jpg'
import g4 from '../../../assets/images/page-img/g4.jpg'
import g5 from '../../../assets/images/page-img/g5.jpg'
import g6 from '../../../assets/images/page-img/g6.jpg'
import g7 from '../../../assets/images/page-img/g7.jpg'
import g8 from '../../../assets/images/page-img/g8.jpg'
import g9 from '../../../assets/images/page-img/g9.jpg'
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import img51 from '../../../assets/images/page-img/51.jpg'
import img52 from '../../../assets/images/page-img/52.jpg'
import img53 from '../../../assets/images/page-img/53.jpg'
import img54 from '../../../assets/images/page-img/54.jpg'
import img55 from '../../../assets/images/page-img/55.jpg'
import img56 from '../../../assets/images/page-img/56.jpg'
import img57 from '../../../assets/images/page-img/57.jpg'
import img58 from '../../../assets/images/page-img/58.jpg'
import img59 from '../../../assets/images/page-img/59.jpg'
import img60 from '../../../assets/images/page-img/60.jpg'
import img61 from '../../../assets/images/page-img/61.jpg'
import img62 from '../../../assets/images/page-img/62.jpg'
import img64 from '../../../assets/images/page-img/64.jpg'
import img65 from '../../../assets/images/page-img/65.jpg'
import img63 from '../../../assets/images/page-img/63.jpg'
import FeedsList from '../../../components/feeds/feedsList'
import CreatePostModal from '../../../components/createPost/createPostModal'
import StoriesSection from '../../../components/stories/storiesSection'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import { setUserData, setCreatePostType, setOrganizationInfo as setOrganizationInfoRedux } from '../../../store/setting/actions'
import { fetchRegistrationPackages, selectAllRegistrations, selectInitialized as selectChildRegistrationInitialized } from '../../../store/childRegistration/childRegistrationSlice';
import { fetchEmergencyContacts, submitEmergencyContact, selectContacts as selectEmergencyContacts, selectInitialized as selectEmergencyContactsInitialized } from '../../../store/emergencyContact/emergencyContactSlice';
import {
   isChildRegistrationRecordFilled,
   isEmbeddedStepFilled,
   filterActiveRecords,
   getRegistrationPacketSteps,
   isRegistrationPacketComplete,
} from '../../../utilities/registrationPacketStatus';

import GalleryImage from '../../../components/gallery/galleryImage'
import GalleryVideo from '../../../components/gallery/galleryVideo'
import GalleryImageCard from '../../../components/gallery/galleryImageCard'
import FeedPostCard from '../../../components/feeds/feedPostCard'
import NoDataFound from '../../../components/noDataFound'
import PictureApproval from '../../../components/pictureApproval/pictureApproval'
import CreatePostInputBox from '../../../components/createPost/createPostInputBox'
import PeopleYouMayKnowCard from '../../../components/peopleYouMayKnow/peopleYouMayKnowCard'

// Fslightbox plugin
const FsLightbox = ReactFsLightbox.default ? ReactFsLightbox.default : ReactFsLightbox;

const UserProfile = () => {
   const getNormalizedQuickbookCards = (res) => {
      const source = res?.data?.data?.user_quickbook_cards || res?.data?.data?.cards || res?.data?.data?.data || [];
      const list = Array.isArray(source) ? source : (Array.isArray(source?.data) ? source.data : []);

      return list
         .filter((card) => Number(card?.status ?? 1) === 1)
         .map((card) => ({
            id: card?.id || card?.user_quickbook_card_id || card?.userQuickbookCardId,
            quickbookCardId: card?.quickbook_card_id || card?.quickbookCardId,
            name: card?.name,
            expYear: card?.exp_year || card?.expYear,
            expMonth: card?.exp_month || card?.expMonth,
            brand: card?.brand || card?.card_brand,
            last4: card?.last4 || card?.card_last4,
         }))
         .filter((card) => card?.id);
   };

   // Registration Packet highlight logic: use API data to determine if registration is complete
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   const user = profileData;
   
   // Get general settings for handbook URL
   let generalSettingsData = (useSelector((state) => state.setting.setting.general_settings))
   generalSettingsData = generalSettingsData ? JSON.parse(generalSettingsData) : "";
   
   // Debug: Log handbook URL
   useEffect(() => {
      if (generalSettingsData) {
         console.log("General Settings Data:", generalSettingsData);
         console.log("Handbook URL:", generalSettingsData?.handbook);
      }
   }, [generalSettingsData]);
   
   // Get child registration data from Redux store
   const childRegistrationData = useSelector(selectAllRegistrations);
   // True once this student's registrations have actually been fetched
   // (success or failure) — see the matching comment in
   // childRegistrationSlice.js. Gates the tab's red dot below so it doesn't
   // flash "incomplete" against the slice's empty initial state before the
   // real fetch has come back.
   const childRegistrationInitialized = useSelector(selectChildRegistrationInitialized);

   // Emergency contacts live in their own table (EMERGENCY_CONTACTS_LIST),
   // not embedded in the PROFILE_DETAILS response - displayProfile.emergency_contacts
   // is never populated, which is why the Family tab's Emergency Contacts
   // card always rendered empty even for a child with contacts on file.
   const emergencyContactsData = useSelector(selectEmergencyContacts);
   const emergencyContactsInitialized = useSelector(selectEmergencyContactsInitialized);

   // Add blinking animation style for warning dot if not already present
   useEffect(() => {
      if (!document.getElementById('blinker-style')) {
         const style = document.createElement('style');
         style.id = 'blinker-style';
         style.innerHTML = `@keyframes blinker { 50% { opacity: 0; } }`;
         document.head.appendChild(style);
      }
   }, []);
   const [show, setShow] = useState(false);
   const navigate = useNavigate();
   const location = useLocation();
   const dispatch = useDispatch()
   // ...existing code...
   const [page, setPage] = useState(1);
   const [maxPage, setMaxPage] = useState(1);
   // Lets the header's "Registration Packet Incomplete" banner deep-link
   // straight into this tab (navigate(..., { state: { activeTab: 'Registration Packet' } }))
   // instead of always landing on Timeline and making the parent hunt for it.
   const [daycareActiveTab, setDaycareActiveTab] = useState(location.state?.activeTab || 'Timeline');
   const [followerList, setFollowerList] = useState([]);
   const [followingList, setFollowingList] = useState([]);
   const [galleryImageList, setGalleryImageList] = useState([]);
   const [galleryVideoList, setGalleryVideoList] = useState([]);
   const [feedsList, setFeedsList] = useState([]);
   const [showLoader, setShowLoader] = useState(false);
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
   const [showInviteParentModal, setShowInviteParentModal] = useState(false);
   const [parentInviteEmail, setParentInviteEmail] = useState('');
   const [sendingParentInvite, setSendingParentInvite] = useState(false);
   // Parent Access tab (student-only): who has access to this student's profile,
   // plus the invitations that led to that access.
   const [parentAccessInvitations, setParentAccessInvitations] = useState([]);
   const [parentAccessInvitationsTotal, setParentAccessInvitationsTotal] = useState(0);
   const [parentAccessAcceptedList, setParentAccessAcceptedList] = useState([]);
   const [parentAccessAcceptedTotal, setParentAccessAcceptedTotal] = useState(0);
   const [parentAccessLoading, setParentAccessLoading] = useState(false);
   const [parentAccessFetchAttempted, setParentAccessFetchAttempted] = useState(false);
   const [parentAccessTogglingId, setParentAccessTogglingId] = useState(null);
   // A parent's own PROFILE_DETAILS response embeds a `children` array (one entry
   // per linked student) directly on profileData.children — merged in by
   // getProfileDetails() below. Fields shown in the header/About/Family/Documents
   // blocks read from displayProfile: the selected child's data for a parent
   // viewer, the viewer's own data otherwise.
   const displayProfile = isParentLoginProfile(profileData) ? (getSelectedChildProfile(profileData) || {}) : profileData;
   // EMERGENCY_CONTACTS_LIST can come back empty even when profile/details
   // embeds the child's contacts - fall back to those for display.
   const familyEmergencyContacts = Array.isArray(emergencyContactsData) && emergencyContactsData.length > 0
      ? emergencyContactsData
      : (Array.isArray(displayProfile?.emergency_contacts) ? displayProfile.emergency_contacts : []);
   const parentChildren = getParentChildren(profileData);
   // Custom "Viewing Child" picker state — a plain <select> can't show a
   // per-child avatar in its options, so this is a hand-rolled dropdown
   // portaled to document.body (see childDropdownMenu below) so its menu
   // isn't clipped by the profile Card's `overflow: hidden`.
   const [isChildDropdownOpen, setIsChildDropdownOpen] = useState(false);
   const [childDropdownRect, setChildDropdownRect] = useState(null);
   const childDropdownToggleRef = useRef(null);
   const childDropdownMenuRef = useRef(null);

   // The tab's red "incomplete" dot now tracks the full 5-step packet
   // (Child Registration, Allergy Action Plan, Lunch Plan Waiver, No Peanut
   // Policy, Emergency Contact) — same shared registrationPacketStatus
   // helpers, and same completeness rule, as the header banner and the
   // in-tab "Registration Incomplete!" banner (isRegistrationComplete
   // further down), so all three agree instead of the dot going quiet
   // whenever just the core Child Registration form was done while other
   // steps were still open. Gated on both slices actually having been
   // fetched (see the matching comment on childRegistrationInitialized
   // above) so it doesn't flash against their empty initial state.
   const registrationPacketIncomplete = childRegistrationInitialized && emergencyContactsInitialized
      && !isRegistrationPacketComplete(getRegistrationPacketSteps({
         childRegistrationData,
         profile: displayProfile,
         emergencyContactsData,
      }));
   const [dailyReportsList, setDailyReportsList] = useState([]);
   const [showDailyReportLoader, setShowDailyReportLoader] = useState(false);
   const [dailyReportStartDate, setDailyReportStartDate] = useState('');
   const [dailyReportEndDate, setDailyReportEndDate] = useState('');
   const [learningGames, setLearningGames] = useState([]);
   const [showLearningLoader, setShowLearningLoader] = useState(false);
   const [learningFetchAttempted, setLearningFetchAttempted] = useState(false);
   const [assignedGames, setAssignedGames] = useState([]);
   const [assignedGamesLoading, setAssignedGamesLoading] = useState(false);
   const [assignedGamesFetchAttempted, setAssignedGamesFetchAttempted] = useState(false);
   const [attendanceList, setAttendanceList] = useState([]);
   const [attendanceStats, setAttendanceStats] = useState(null);
   const [attendanceSession, setAttendanceSession] = useState(null);
   const [attendanceStudent, setAttendanceStudent] = useState(null);
   const [showAttendanceLoader, setShowAttendanceLoader] = useState(false);
   const [attendanceFetchAttempted, setAttendanceFetchAttempted] = useState(false);
   const [attendanceSelectedMonth, setAttendanceSelectedMonth] = useState(Moment().startOf('month'));
   const [organizationInfo, setOrganizationInfo] = useState(null);
   const [financeActiveTab, setFinanceActiveTab] = useState('transactions');
   const [financeTransactionType, setFinanceTransactionType] = useState('unpaid');
   const [gradeTransactions, setGradeTransactions] = useState([]);
   const [gradeTransactionsMeta, setGradeTransactionsMeta] = useState(null);
   const [showFinanceTransactionsLoader, setShowFinanceTransactionsLoader] = useState(false);
   const [userSubsidy, setUserSubsidy] = useState(null);
   const [showFinancePayModal, setShowFinancePayModal] = useState(false);
   const [financeModalView, setFinanceModalView] = useState('pay');
   const [selectedFinanceTransaction, setSelectedFinanceTransaction] = useState(null);
   const [financeSavedCards, setFinanceSavedCards] = useState([]);
   const [selectedFinanceCardId, setSelectedFinanceCardId] = useState('');
   const [isFinancePaymentSubmitting, setIsFinancePaymentSubmitting] = useState(false);
   // inline add-card states
   const [newCardHolder, setNewCardHolder] = useState('');
   const [newCardNumber, setNewCardNumber] = useState('');
   const [newCardExpMonth, setNewCardExpMonth] = useState('01');
   const [newCardExpYear, setNewCardExpYear] = useState(String(new Date().getFullYear()));
   const [newCardCvv, setNewCardCvv] = useState('');
   const [newCardZip, setNewCardZip] = useState('');
   const [isAddCardSubmitting, setIsAddCardSubmitting] = useState(false);
   const [isCompactViewport, setIsCompactViewport] = useState(() => {
      if (typeof window === 'undefined') return false;
      return window.innerWidth < 1200;
   });

   // Allergy Action Plan / Lunch Plan Waiver / No Peanut Policy no longer
   // have their own Form/List here - ChildRegistrationFormComp now collects
   // all 3 inline as part of the Child Registration step below, and reading
   // them back once filled (its own pre-filled/editable fields, not a
   // separate summary) is likewise handled entirely inside that component.
   // A separate step for each here would just be a duplicate entry point.
   const ChildRegistrationFormComp = React.lazy(() => import('../../../components/registrationPacket/ChildRegistrationFormComp'));
   const EmergencyContactFormComp = React.lazy(() => import('../../../components/registrationPacket/EmergencyContactFormComp'));

   const ChildRegistrationListComp = React.lazy(() => import('../../../components/registrationPacket/ChildRegistrationListComp'));
   const EmergencyContactListComp = React.lazy(() => import('../../../components/registrationPacket/EmergencyContactListComp'));

   const [imageController, setImageController] = useState({
      toggler: false,
      slide: 1
   });
   function imageOnSlide(number) {
      setImageController({
         toggler: !imageController.toggler,
         slide: number
      });
   }

   const [isFirst, setIsFirst] = useState(true);
   useEffect(() => {
      window.scrollTo({
         top: 0,
         behavior: "smooth",
      });
      setIsFirst(false)
   }, [isFirst]);

   // Re-apply the header banner's requested tab even when landing here while
   // already on this route — the useState initializer above only runs once,
   // so a second click on the banner while already viewing the profile
   // (a `state`-only navigation, same pathname) would otherwise be a no-op.
   useEffect(() => {
      if (location.state?.activeTab) {
         setDaycareActiveTab(location.state.activeTab);
      }
   }, [location.state]);

   // Ensure active tab is valid based on user type and data availability
   useEffect(() => {
      const isStudent = isStudentLoginProfile(profileData);
      const restrictedTabs = ['Timeline', 'About', 'Media'];
      
      if (!isStudent && !restrictedTabs.includes(daycareActiveTab)) {
         // If teacher/admin and current tab is not in restricted list, switch to Timeline
         setDaycareActiveTab('Timeline');
      }
   }, [profileData, daycareActiveTab]);

   // The tab strip below scrolls horizontally on narrow screens (there are
   // up to 10 tabs for a student profile) but nothing kept the active tab
   // in view — tapping a later tab (or landing on one via the "Registration
   // Packet Incomplete" banner deep-link above) left earlier tabs like
   // "Attendance" scrolled half off the left edge with no indication more
   // tabs existed there. Scrolls whichever tab is active into view whenever
   // it changes, from any of the paths that call setDaycareActiveTab.
   useEffect(() => {
      const activeTabEl = document.querySelector(`[data-daycare-tab="${daycareActiveTab}"]`);
      if (activeTabEl) {
         activeTabEl.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
   }, [daycareActiveTab]);

   useEffect(() => {
      console.log("token", localStorage.getItem("uzoneAuthToken"))
      dispatch(setCreatePostType("0"))
      if (localStorage.getItem("uzoneAuthToken")) {
         getProfileDetails()
         getFollowerList()
         getFollowingList()
         getGalleryImage()
         getGalleryVideo()
         getDailyReportsList()
      } else {
         navigate('/')
      }
   }, []);

   useEffect(() => {
      const handleResize = () => {
         setIsCompactViewport(window.innerWidth < 1200);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   useEffect(() => {
      if (daycareActiveTab === 'Finance') {
         getGradeTransactionsApi(financeTransactionType, 1);
      }

      if (daycareActiveTab === 'Learning' && !learningFetchAttempted) {
         getLearningPlayedGames();
      }

      if (daycareActiveTab === 'Learning' && !assignedGamesFetchAttempted) {
         getAssignedGames();
      }
   }, [daycareActiveTab, learningFetchAttempted, assignedGamesFetchAttempted, financeTransactionType]);

   useEffect(() => {
      if (daycareActiveTab === 'Attendance') {
         getStudentAttendanceApi(attendanceSelectedMonth);
      }
   }, [daycareActiveTab, attendanceSelectedMonth]);

   useEffect(() => {
      if (daycareActiveTab === 'Parent Access' && !parentAccessFetchAttempted) {
         getParentAccessData();
      }
   }, [daycareActiveTab, parentAccessFetchAttempted]);

   // The "Child Registration" step of the Registration Packet tab reads
   // childRegistrationData (fetched separately via fetchRegistrationPackages,
   // unlike the other steps which read straight off displayProfile). Every
   // other tab here re-fetches its own data when it becomes active; this one
   // previously relied solely on the one-time fetch inside getProfileDetails()
   // at mount, so opening this tab after landing on a different default tab
   // (e.g. via the "My Profile" nav link) could show it before that fetch
   // resolved, or with data left over from a since-changed child. Re-fetching
   // on tab-activation matches the standalone /dashboard/child-registration/list
   // page, which fetches fresh on every mount and is not affected by this.
   useEffect(() => {
      if (daycareActiveTab === 'Registration Packet') {
         dispatch(fetchRegistrationPackages({ page: 1, limit: 100, student_id: getEffectiveStudentId(profileData) }));
      }
   }, [daycareActiveTab]);

   // Same story as the Child Registration fetch above: Emergency Contacts
   // isn't embedded in the profile response either, and now feeds both the
   // Family tab's Emergency Contacts card AND the Registration Packet tab's
   // 5th step - fetch fresh from EMERGENCY_CONTACTS_LIST when either becomes
   // active.
   useEffect(() => {
      if (daycareActiveTab === 'Family' || daycareActiveTab === 'Registration Packet') {
         dispatch(fetchEmergencyContacts({ page: 1, limit: 100, student_id: getEffectiveStudentId(profileData) }));
      }
   }, [daycareActiveTab]);

   async function getProfileDetails() {
      try {
         const res = await apiHandler(PROFILE_DETAILS, "POST")
         if (res.data?.response?.status === 200) {
            //console.log("profileRes", res)
            //setProfileData(res?.data?.data?.user)
            // A parent's own PROFILE_DETAILS response includes a sibling `children`
            // array (one entry per linked student, each with its full profile
            // already populated) instead of a single student_id on the user object.
            // Merge it into the same user_data object, along with whichever child
            // was previously selected, so getEffectiveStudentId/displayProfile keep
            // working from any screen without a second network call.
            const rawUser = res?.data?.data?.user;
            const children = res?.data?.data?.children;
            const mergedUser = {
               ...rawUser,
               ...(Array.isArray(children) ? { children } : {}),
               ...(profileData?.selected_student_id ? { selected_student_id: profileData.selected_student_id } : {}),
            };
            dispatch(setUserData(JSON.stringify(mergedUser)));
            if (res?.data?.data?.organization_info) {
               setOrganizationInfo(res.data.data.organization_info);
               dispatch(setOrganizationInfoRedux(res.data.data.organization_info));
            }
            setUserSubsidy(res?.data?.data?.user_subsidy || null);

            const effectiveStudentId = getEffectiveStudentId(mergedUser);
            getFeedsList(effectiveStudentId, 1)
            // Fetch registration package data
            await dispatch(fetchRegistrationPackages({ page: 1, limit: 100, student_id: effectiveStudentId })).unwrap();
         } else {
            const statusCode = Number(res?.data?.response?.status || 0);
            if (statusCode === 401) {
               navigate('/auth/sign-in')
               return;
            }

            Swal.fire({
               title: 'Unable to Load Profile',
               text: res?.data?.response?.message || 'Please try again.',
               icon: 'warning',
               confirmButtonText: 'OK'
            });
         }
      } catch (error) {
         console.error(error);
         Swal.fire({
            title: 'Unable to Load Profile',
            text: 'A network or server error occurred. Please retry.',
            icon: 'warning',
            confirmButtonText: 'OK'
         });
      }
      finally {
      }
   }

   async function sendParentInvitation() {
      if (!parentInviteEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(parentInviteEmail)) {
         Swal.fire({ title: 'Error', text: 'Please enter a valid email address', icon: 'error', confirmButtonText: 'Okay' });
         return;
      }

      const confirmResult = await Swal.fire({
         title: 'Send this invitation?',
         text: `An invitation to access your profile will be sent to ${parentInviteEmail}.`,
         icon: 'question',
         showCancelButton: true,
         confirmButtonText: 'Yes, send it',
         cancelButtonText: 'Cancel',
      });

      if (!confirmResult.isConfirmed) {
         return;
      }

      setSendingParentInvite(true);
      try {
         const res = await apiHandler(SEND_PARENT_INVITATION, 'POST', { email: parentInviteEmail });
         if (res.data?.response?.status === 200) {
            Swal.fire({ title: 'Success', text: 'Parent invitation sent successfully', icon: 'success', confirmButtonText: 'Okay' });
            setShowInviteParentModal(false);
            setParentInviteEmail('');
            // Refresh the Parent Access tab's counts/list right away so a newly
            // sent invitation shows up without the student having to switch
            // tabs or reload the page.
            getParentAccessData();
         } else {
            Swal.fire({ title: 'Error', text: res?.data?.response?.message || res?.response?.data?.data?.message || 'Unable to send invitation', icon: 'error', confirmButtonText: 'Okay' });
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
         setSendingParentInvite(false);
      }
   }

   // Parent Access tab (student-only): loads both the list of parents who
   // currently have (or once had) access to this profile and the invitations
   // sent to reach that state, so the counts (sent / signed up / active) and
   // the access-toggle list can be derived from the same fetch.
   async function getParentAccessData() {
      setParentAccessLoading(true);
      setParentAccessFetchAttempted(true);
      try {
         const [invitationRes, acceptedRes] = await Promise.all([
            apiHandler(PARENT_INVITATION_LIST, 'POST', { page: 1, limit: 50 }),
            apiHandler(ACCEPTED_PARENT_LIST, 'POST', { page: 1, limit: 50 }),
         ]);

         if (invitationRes?.data?.response?.status === 200) {
            setParentAccessInvitations(invitationRes?.data?.data?.invitations?.data || []);
            setParentAccessInvitationsTotal(invitationRes?.data?.data?.invitations?.meta?.total ?? 0);
         } else {
            setParentAccessInvitations([]);
            setParentAccessInvitationsTotal(0);
         }

         if (acceptedRes?.data?.response?.status === 200) {
            setParentAccessAcceptedList(acceptedRes?.data?.data?.parents?.data || []);
            setParentAccessAcceptedTotal(acceptedRes?.data?.data?.parents?.meta?.total ?? 0);
         } else {
            setParentAccessAcceptedList([]);
            setParentAccessAcceptedTotal(0);
         }
      } catch (error) {
         console.error('Error fetching parent access data:', error);
         setParentAccessInvitations([]);
         setParentAccessInvitationsTotal(0);
         setParentAccessAcceptedList([]);
         setParentAccessAcceptedTotal(0);
      } finally {
         setParentAccessLoading(false);
      }
   }

   // Flips a parent's access on/off. status: 1 = active (can view this
   // profile), 0 = deactivated (access revoked but the connection is kept, so
   // it can be re-activated later instead of re-inviting).
   async function toggleParentAccessStatus(parentEntry) {
      const parentId = parentEntry?.parent_id;
      if (!parentId || parentAccessTogglingId) {
         return;
      }
      const nextStatus = parentEntry?.status === 1 ? 0 : 1;
      const isDeactivating = nextStatus === 0;

      const confirmResult = await Swal.fire({
         title: isDeactivating ? 'Deactivate parent access?' : 'Activate parent access?',
         text: isDeactivating
            ? `${parentEntry?.parent?.first_name || 'This parent'} will no longer be able to view your profile.`
            : `${parentEntry?.parent?.first_name || 'This parent'} will regain access to your profile.`,
         icon: 'warning',
         showCancelButton: true,
         confirmButtonText: isDeactivating ? 'Yes, deactivate' : 'Yes, activate',
         cancelButtonText: 'Cancel',
      });

      if (!confirmResult.isConfirmed) {
         return;
      }

      setParentAccessTogglingId(parentId);
      try {
         const res = await apiHandler(TOGGLE_PARENT_ACCESS, 'POST', { parent_id: parentId, status: nextStatus });
         if (res?.data?.response?.status === 200) {
            setParentAccessAcceptedList((prev) => prev.map((item) => (
               item.parent_id === parentId ? { ...item, status: nextStatus } : item
            )));
            Swal.fire({
               title: 'Success',
               text: res?.data?.data?.message || 'Parent access updated successfully',
               icon: 'success',
               confirmButtonText: 'Okay',
            });
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.data?.response?.message || 'Unable to update parent access',
               icon: 'error',
               confirmButtonText: 'Okay',
            });
         }
      } catch (error) {
         console.error('Error toggling parent access:', error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
         setParentAccessTogglingId(null);
      }
   }

   // Merges the invitation list and the accepted/connected list into one set of
   // rows (matched by email) so the Parent Access tab shows a single "who has —
   // or is on their way to getting — access" list instead of two separate
   // tables that otherwise show the same parent twice (once as an invite, again
   // as a connection) once they've signed up.
   function getCombinedParentRows() {
      const rows = [];
      const matchedAcceptedIds = new Set();

      parentAccessInvitations.forEach((invite) => {
         const matchedAccepted = parentAccessAcceptedList.find((accepted) => (
            (accepted?.parent?.email || '').toLowerCase() === (invite?.email || '').toLowerCase()
         ));
         if (matchedAccepted) {
            matchedAcceptedIds.add(matchedAccepted.id);
         }

         rows.push({
            key: `invite-${invite.id}`,
            parentName: matchedAccepted
               ? `${matchedAccepted.parent?.first_name || ''} ${matchedAccepted.parent?.last_name || ''}`.trim()
               : '',
            email: invite.email,
            refCode: invite.ref_code,
            date: matchedAccepted?.created_at || invite.created_at,
            status: matchedAccepted ? (matchedAccepted.status === 1 ? 'active' : 'deactivated') : 'pending',
            accepted: matchedAccepted || null,
         });
      });

      // Connected parents with no matching invitation on file (e.g. linked some
      // other way) still need to show up and be toggleable.
      parentAccessAcceptedList.forEach((accepted) => {
         if (matchedAcceptedIds.has(accepted.id)) {
            return;
         }
         rows.push({
            key: `accepted-${accepted.id}`,
            parentName: `${accepted.parent?.first_name || ''} ${accepted.parent?.last_name || ''}`.trim(),
            email: accepted?.parent?.email || '',
            refCode: '',
            date: accepted.created_at,
            status: accepted.status === 1 ? 'active' : 'deactivated',
            accepted,
         });
      });

      return rows;
   }

   // Switches which linked child a parent is viewing. The selected child's id is
   // stored in localStorage (setStoredParentStudentId) — the single canonical
   // value apiHandler attaches to every API call from here on — and mirrored
   // onto profileData.selected_student_id purely so the child-selector dropdown
   // re-renders immediately. Every child-scoped list is also explicitly
   // re-fetched with the new id here, since profileData itself won't reflect
   // the dispatch until the next render (stale-closure otherwise).
   const handleSelectChild = (newChildId) => {
      if (!newChildId || String(newChildId) === String(getEffectiveStudentId(profileData))) {
         return;
      }

      setStoredParentStudentId(newChildId);
      dispatch(setUserData(JSON.stringify({ ...profileData, selected_student_id: newChildId })));

      setPage(1);
      getFeedsList(newChildId, 1);
      getGalleryImage(newChildId);
      getGalleryVideo(newChildId);
      getDailyReportsList(null, null, newChildId);
      getFollowerList(newChildId);
      getFollowingList(newChildId);
      getGradeTransactionsApi(financeTransactionType, 1, newChildId);
      getLearningPlayedGames(newChildId);
      getAssignedGames(newChildId);
      getStudentAttendanceApi(attendanceSelectedMonth, newChildId);
      dispatch(fetchRegistrationPackages({ page: 1, limit: 100, student_id: newChildId }));
      // Emergency Contacts has the same "own table, not embedded on the
      // child" shape as Child Registration above - without this, switching
      // children while already on the Registration Packet or Family tab left
      // the Emergency Contact step/card showing the previously-selected
      // child's contacts until the tab was left and re-opened (the only
      // other place this gets fetched is that tab-activation effect, which
      // doesn't re-fire just because the selected child changed).
      dispatch(fetchEmergencyContacts({ page: 1, limit: 100, student_id: newChildId }));
   };

   // Positions the portaled child-picker menu under its toggle, and closes it
   // on outside click / Escape / scroll-resize so it behaves like a normal
   // dropdown despite living outside the Card in the DOM.
   useEffect(() => {
      if (!isChildDropdownOpen) {
         return;
      }

      const updatePosition = () => {
         const rect = childDropdownToggleRef.current?.getBoundingClientRect();
         if (rect) {
            setChildDropdownRect(rect);
         }
      };
      updatePosition();

      const handleOutsideInteraction = (event) => {
         if (
            childDropdownToggleRef.current?.contains(event.target) ||
            childDropdownMenuRef.current?.contains(event.target)
         ) {
            return;
         }
         setIsChildDropdownOpen(false);
      };
      const handleKeyDown = (event) => {
         if (event.key === 'Escape') {
            setIsChildDropdownOpen(false);
         }
      };

      document.addEventListener('mousedown', handleOutsideInteraction);
      document.addEventListener('keydown', handleKeyDown);
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);

      return () => {
         document.removeEventListener('mousedown', handleOutsideInteraction);
         document.removeEventListener('keydown', handleKeyDown);
         window.removeEventListener('scroll', updatePosition, true);
         window.removeEventListener('resize', updatePosition);
      };
   }, [isChildDropdownOpen]);

   // Submission handlers for registration packet forms
   //
   // Allergy Action Plan / Lunch Plan Waiver / No Peanut Policy no longer
   // have their own submit handler here - ChildRegistrationFormComp submits
   // all 3 directly (to the same submitAllergyActionPlan /
   // submitLunchPlanWaiver / submitNoPeanutPolicy thunks) as part of
   // handling its own registration submit.
   //
   // Emergency Contact still has its own handler/step below - its data
   // isn't embedded in the profile response (it's its own table), so the
   // post-submit refresh re-fetches from EMERGENCY_CONTACTS_LIST instead of
   // re-pulling the whole profile.
   const handleEmergencyContactSubmit = async (formData) => {
      try {
         await dispatch(submitEmergencyContact({ ...formData, student_id: getEffectiveStudentId(profileData) })).unwrap();
         await Swal.fire({
            title: 'Success!',
            text: 'Emergency contact submitted successfully.',
            icon: 'success',
            timer: 2000
         });
         await dispatch(fetchEmergencyContacts({ page: 1, limit: 100, student_id: getEffectiveStudentId(profileData) }));
      } catch (error) {
         Swal.fire({
            title: 'Error!',
            text: error || 'Failed to submit emergency contact.',
            icon: 'error'
         });
      }
   };

   const loadMore = (inView) => {
      if (inView) {
         if (page < maxPage) {
            getFeedsList(getEffectiveStudentId(profileData), page + 1)
            //console.log("scroll working...", page + 1)
            setPage(page + 1)
         }
      }
   };

   function refreshApi() {
      setPage(1)
      getFeedsList(getEffectiveStudentId(profileData), 1)
   }

   async function getFeedsList(userId, pageVal) {
      setShowMoreDataLoader(true)
      //setShowLoader(true)
      try {
         const res = await apiHandler(FEEDS_LIST, "POST", {
            user_id: userId,
            page: pageVal,
            limit: 10,
         })
         if (res.data?.response?.status === 200) {
            setMaxPage(res?.data?.data?.feeds?.meta?.last_page)
            if (pageVal === 1) {
               setFeedsList(res?.data?.data?.feeds?.data)
            } else {
               setFeedsList(feedsList.concat(res?.data?.data?.feeds?.data))
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
         setShowMoreDataLoader(false)
         //setShowLoader(false)
      }
   }

   async function getFollowerList(overrideStudentId) {
      try {
         const res = await apiHandler(FOLLOWER_LIST, "POST", {
            page: 1,
            limit: 9,
            student_id: overrideStudentId ?? getEffectiveStudentId(profileData)
         })
         if (res.data?.response?.status === 200) {
            if (res?.data?.data?.followers?.meta?.total > 0) {
               setFollowerList(res?.data?.data?.followers?.data || [])
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      }
      finally {
      }
   }

   async function getFollowingList(overrideStudentId) {
      try {
         const res = await apiHandler(FOLLOWING_LIST, "POST", {
            page: 1,
            limit: 9,
            student_id: overrideStudentId ?? getEffectiveStudentId(profileData)
         })
         if (res.data?.response?.status === 200) {
            if (res?.data?.data?.followings?.meta?.total > 0) {
               setFollowingList(res?.data?.data?.followings?.data || [])
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
      }
   }

   async function getGalleryImage(overrideStudentId) {
      try {
         const res = await apiHandler(PROFILE_GALLERY, "POST", {
            user_id: overrideStudentId ?? getEffectiveStudentId(profileData),
            media_type: 0,
            page_no: 1,
            limit: 1000,
         })
         if (res.data?.response?.status === 200) {
            if (res?.data?.data?.userPostImages?.meta?.total > 0) {
               setGalleryImageList(res?.data?.data?.userPostImages?.data)
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
      }
   }

   async function getGalleryVideo(overrideStudentId) {
      try {
         const res = await apiHandler(PROFILE_GALLERY, "POST", {
            user_id: overrideStudentId ?? getEffectiveStudentId(profileData),
            media_type: 1,
            page_no: 1,
            limit: 1000,
         })
         if (res.data?.response?.status === 200) {
            if (res?.data?.data?.userPostImages?.meta?.total > 0) {
               setGalleryVideoList(res?.data?.data?.userPostImages?.data)
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      } finally {
      }
   }

   const handleCoverImageChange = (event) => {
      setShowLoader(true)
      const file = event.target.files[0];
      if (file) {
         const reader = new FileReader();

         reader.onloadend = async () => {
            //setPreviewImage(reader.result);
            const fileCon = new File([file], `coverImage${Date.now()}.jpg`, { type: 'image/jpeg' });
            const url = await handleImageUpload(file, "coverImage/", "image/jpeg")
            // const url = await handleImageUpload(file, "feedImages/", "image/jpeg")
            updateCoverPicApi(url)
         };
         reader.readAsDataURL(file);
      }
   };

   async function updateCoverPicApi(url) {
      try {
         const res = await apiHandler(PROFILE_COVER_PIC_UPDATE, "POST", {
            cover_photo: url,
            student_id: getEffectiveStudentId(profileData),
         })
         if (res.data?.response?.status == 200) {
            //setProfileData(res?.data?.data?.user)
            //addToast("Updated Successfully.");
            //setProfileImage(url)
            // This response is the acting account's own record — never redispatch
            // it verbatim, or a parent's children/selected_student_id would be lost.
            // Preserve them, and refresh the child list too since cover photo may
            // belong to the child rather than the parent's own profile.
            const updatedOwnUser = res?.data?.data?.user;
            dispatch(setUserData(JSON.stringify({
               ...updatedOwnUser,
               ...(Array.isArray(profileData?.children) ? { children: profileData.children } : {}),
               ...(profileData?.selected_student_id ? { selected_student_id: profileData.selected_student_id } : {}),
            })));
            Swal.fire({
               title: 'Success!',
               text: 'Your cover image uploaded successfully.',
               icon: 'success',
               confirmButtonText: 'Okay'
            })
         } else if (res.data?.response?.status == 400) {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message,
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message,
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error);
         Swal.fire({ title: 'Error', text: 'A network or server error occurred. Please retry.', icon: 'error', confirmButtonText: 'Okay' });
      }
      finally {
         setShowLoader(false)
      }
   }

   const stripHtml = (text) => {
      if (!text) return '';
      return String(text).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
   };

   const formatTime = (timeString) => {
      if (!timeString) return 'N/A';
      const [hours, minutes] = timeString.split(':');
      const hour24 = parseInt(hours);
      const min = parseInt(minutes);
      const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
      const ampm = hour24 >= 12 ? 'PM' : 'AM';
      return `${hour12}:${min.toString().padStart(2, '0')} ${ampm}`;
   };

   const getMealAmountLabel = (amount) => {
      const labels = { 0: 'None', 1: 'Some', 2: 'Half', 3: 'Most', 4: 'All', 5: 'All+' };
      return labels[Number(amount)] || 'None';
   };

   const getAgeLabel = (dob) => {
      if (!dob) return 'Age not available';
      const dobMoment = Moment(dob);
      if (!dobMoment.isValid()) return 'Age not available';

      const now = Moment();
      let years = now.diff(dobMoment, 'years');
      const shiftedDob = dobMoment.clone().add(years, 'years');
      let months = now.diff(shiftedDob, 'months');

      if (years < 0 || months < 0) return 'Age not available';

      const yearLabel = `${years} ${years === 1 ? 'year' : 'years'}`;
      const monthLabel = `${months} ${months === 1 ? 'month' : 'months'}`;
      return `${yearLabel} and ${monthLabel}`;
   };

   const formatCurrency = (value) => {
      const numberValue = Number(value || 0);
      return `$${numberValue.toFixed(2)}`;
   };

   const getTransactionStatusLabel = (status) => {
      if (status === 1 || status === '1') return 'Paid';
      if (status === 2 || status === '2') return 'Partially Paid';
      return 'Outstanding';
   };

   const getTransactionStatusStyle = (status) => {
      if (status === 1 || status === '1') {
         return { background: '#dcfce7', color: '#15803d' };
      }
      if (status === 2 || status === '2') {
         return { background: '#fef3c7', color: '#b45309' };
      }
      return { background: '#fee2e2', color: '#b91c1c' };
   };

   const getSubsidyStatus = (subsidy) => {
      if (!subsidy?.start_date || !subsidy?.end_date) return 'Unknown';
      const now = Moment();
      const start = Moment(subsidy.start_date);
      const end = Moment(subsidy.end_date);
      if (!start.isValid() || !end.isValid()) return 'Unknown';
      if (now.isBefore(start, 'day')) return 'Upcoming';
      if (now.isAfter(end, 'day')) return 'Expired';
      return 'Active';
   };

   async function getGradeTransactionsApi(type = 'unpaid', pageVal = 1, overrideStudentId) {
      setShowFinanceTransactionsLoader(true);
      try {
         const res = await apiHandler(GRADE_TRANSACTIONS, 'POST', {
            page: pageVal,
            type,
            student_id: overrideStudentId ?? getEffectiveStudentId(profileData),
         });
         if (res?.data?.response?.status === 200) {
            setGradeTransactions(res?.data?.data?.grade?.data || []);
            setGradeTransactionsMeta(res?.data?.data?.grade?.meta || null);
         } else {
            setGradeTransactions([]);
            setGradeTransactionsMeta(null);
         }
      } catch (error) {
         console.error('Error fetching grade transactions:', error);
         setGradeTransactions([]);
         setGradeTransactionsMeta(null);
      } finally {
         setShowFinanceTransactionsLoader(false);
      }
   }

   const handleFinanceTransactionTypeChange = (type) => {
      setFinanceTransactionType(type);
      getGradeTransactionsApi(type, 1);
   };

   const formatFinanceCardInput = (value) => {
      const raw = value.replace(/\D/g, '').slice(0, 16);
      return raw.replace(/(.{4})/g, '$1 ').trim();
   };

   const getFinanceSavedQuickbookCards = async () => {
      const res = await apiHandler(QUICKBOOK_CARD_LIST, 'POST', { student_id: getEffectiveStudentId(profileData) });
      if (res?.data?.response?.status !== 200) {
         return [];
      }
      return getNormalizedQuickbookCards(res);
   };

   const openFinancePayModal = async (transaction) => {
      const cards = await getFinanceSavedQuickbookCards();
      setSelectedFinanceTransaction(transaction);
      setFinanceSavedCards(cards);
      setSelectedFinanceCardId(String(cards[0]?.id || ''));
      setFinanceModalView(cards.length ? 'pay' : 'add-card');
      // reset add-card fields
      setNewCardHolder('');
      setNewCardNumber('');
      setNewCardExpMonth('01');
      setNewCardExpYear(String(new Date().getFullYear()));
      setNewCardCvv('');
      setNewCardZip('');
      setShowFinancePayModal(true);
   };

   const addFinanceCard = async () => {
      if (!newCardHolder.trim()) {
         Swal.fire({ title: 'Required', text: 'Please enter card holder name.', icon: 'warning', confirmButtonText: 'OK' });
         return;
      }
      const cleanNumber = newCardNumber.replace(/\s/g, '');
      if (cleanNumber.length < 12) {
         Swal.fire({ title: 'Required', text: 'Please enter a valid card number.', icon: 'warning', confirmButtonText: 'OK' });
         return;
      }
      if (!newCardCvv.trim() || newCardCvv.trim().length < 3) {
         Swal.fire({ title: 'Required', text: 'Please enter a valid CVV.', icon: 'warning', confirmButtonText: 'OK' });
         return;
      }

      setIsAddCardSubmitting(true);
      try {
         const tokenApiUrl = process.env.REACT_APP_QUICKBOOK_TOKEN_URL || 'https://api.intuit.com/quickbooks/v4/payments/tokens';
         const tokenResponse = await axios.post(
            tokenApiUrl,
            {
               card: {
                  name: newCardHolder.trim(),
                  number: cleanNumber,
                  expMonth: newCardExpMonth,
                  expYear: newCardExpYear,
                  cvc: newCardCvv.trim(),
                  address: { postalCode: newCardZip, country: 'US' }
               }
            },
            { headers: { 'Content-Type': 'application/json' } }
         );

         const quickbookToken = tokenResponse?.data?.value;
         if (!quickbookToken) {
            Swal.fire({ title: 'Error', text: 'Unable to tokenize card with QuickBooks. Please try again.', icon: 'error', confirmButtonText: 'OK' });
            return;
         }

         const saveRes = await apiHandler(QUICKBOOK_CARD_SAVE, 'POST', {
            token: quickbookToken,
            name: newCardHolder.trim() || undefined,
            student_id: getEffectiveStudentId(profileData),
         });

         if (saveRes?.data?.response?.status !== 200) {
            Swal.fire({ title: 'Error', text: saveRes?.data?.response?.message || 'Unable to save card.', icon: 'error', confirmButtonText: 'OK' });
            return;
         }

         const refreshedCards = await getFinanceSavedQuickbookCards();
         setFinanceSavedCards(refreshedCards);
         setSelectedFinanceCardId(String(refreshedCards[0]?.id || ''));
         setFinanceModalView('pay');

         Swal.fire({ title: 'Card Added', text: saveRes?.data?.response?.message || 'Card tokenized and saved successfully.', icon: 'success', confirmButtonText: 'OK' });
      } catch (error) {
         const msg = error?.response?.data?.errors?.[0]?.message || 'Something went wrong while tokenizing card.';
         Swal.fire({ title: 'Error', text: msg, icon: 'error', confirmButtonText: 'OK' });
      } finally {
         setIsAddCardSubmitting(false);
      }
   };

   const closeFinancePayModal = () => {
      if (isFinancePaymentSubmitting || isAddCardSubmitting) return;
      setShowFinancePayModal(false);
      setSelectedFinanceTransaction(null);
      setFinanceSavedCards([]);
      setSelectedFinanceCardId('');
      setFinanceModalView('pay');
   };

   const submitFinanceTransactionPayment = async () => {
      if (!selectedFinanceCardId) {
         Swal.fire({
            title: 'Card Required',
            text: 'Please select a saved QuickBooks card to continue.',
            icon: 'warning',
            confirmButtonText: 'OK'
         });
         return;
      }

      if (!selectedFinanceTransaction?.id) {
         Swal.fire({
            title: 'Invalid Transaction',
            text: 'Grade transaction id is missing.',
            icon: 'error',
            confirmButtonText: 'OK'
         });
         return;
      }

      setIsFinancePaymentSubmitting(true);
      try {
         const res = await apiHandler(GRADE_TRANSACTION_PAY, 'POST', {
            grade_transaction_id: selectedFinanceTransaction.id,
            payment_method: 0,
            user_quickbook_card_id: selectedFinanceCardId,
            student_id: getEffectiveStudentId(profileData),
         });

         if (res?.data?.response?.status === 200) {
            Swal.fire({
               title: 'Payment Successful',
               text: res?.data?.data?.message || 'Transaction paid successfully.',
               icon: 'success',
               confirmButtonText: 'OK'
            });
            closeFinancePayModal();
            getGradeTransactionsApi(financeTransactionType, 1);
         } else {
            Swal.fire({
               title: 'Payment Failed',
               text: res?.data?.response?.message || 'Unable to process payment right now.',
               icon: 'error',
               confirmButtonText: 'OK'
            });
         }
      } catch (error) {
         Swal.fire({
            title: 'Payment Failed',
            text: error?.response?.data?.response?.message || 'Something went wrong while paying this transaction.',
            icon: 'error',
            confirmButtonText: 'OK'
         });
      } finally {
         setIsFinancePaymentSubmitting(false);
      }
   };

   async function getDailyReportsList(startDate = null, endDate = null, overrideStudentId) {
      setShowDailyReportLoader(true);
      try {
         const requestData = { student_id: overrideStudentId ?? getEffectiveStudentId(profileData) };

         if (startDate) {
            requestData.start_date = startDate;
         }

         if (endDate) {
            requestData.end_date = endDate;
         }

         const res = await apiHandler(DAILY_REPORTS_LIST, "POST", requestData)
         if (res.data?.response?.status === 200) {
            const reports = res?.data?.data?.data?.data || res?.data?.data?.data || [];
            setDailyReportsList(Array.isArray(reports) ? reports : [])
         } else {
            console.error("Failed to fetch daily reports", res?.data?.response?.message);
         }
      } catch (error) {
         console.error("Error fetching daily reports:", error);
      } finally {
         setShowDailyReportLoader(false);
      }
   }

   const normalizePlayedGameRows = (games = [], categoryName = '') => {
      if (!Array.isArray(games)) return [];

      return games
         .map((game) => {
            const allAttempts = Array.isArray(game?.game_users) ? game.game_users : [];
            const completedAttempts = allAttempts.filter((attempt) => Number(attempt?.is_complete) === 1);

            if (completedAttempts.length === 0) return null;

            const bestScore = completedAttempts.reduce((max, attempt) => {
               const scoreValue = Number(attempt?.score || 0);
               return scoreValue > max ? scoreValue : max;
            }, 0);

            const latestAttempt = completedAttempts.reduce((latest, attempt) => {
               const latestDate = latest
                  ? Moment(latest?.updated_at || latest?.created_at)
                  : null;
               const currentDate = Moment(attempt?.updated_at || attempt?.created_at);

               if (!latestDate || !latestDate.isValid()) return attempt;
               if (!currentDate.isValid()) return latest;
               return currentDate.isAfter(latestDate) ? attempt : latest;
            }, null);

            return {
               id: game?.id,
               name: game?.name || game?.title || 'Untitled Game',
               category: game?.game_category?.name || categoryName || 'General',
               bestScore,
               totalAttempts: allAttempts.length,
               completedAttempts: completedAttempts.length,
               lastPlayedAt: latestAttempt?.updated_at || latestAttempt?.created_at || null,
            };
         })
         .filter(Boolean);
   };

   async function getLearningPlayedGames(overrideStudentId) {
      setShowLearningLoader(true);
      setLearningFetchAttempted(true);

      try {
         const categories = (await fetchAllGameCategories()) || [];

         const learningStudentId = overrideStudentId ?? getEffectiveStudentId(profileData);
         const requests = categories.length > 0
            ? categories.map((category) => apiHandler(GAME_LIST, 'POST', {
               page: 1,
               limit: 100,
               category_id: category?.id || '',
               student_id: learningStudentId,
            }))
            : [apiHandler(GAME_LIST, 'POST', { page: 1, limit: 100, category_id: '', student_id: learningStudentId })];

         const responses = await Promise.all(requests);
         const mergedMap = new Map();

         responses.forEach((response, index) => {
            if (response?.data?.response?.status !== 200) return;

            const games = response?.data?.data?.data?.data || [];
            const categoryName = categories[index]?.name || '';
            const playedRows = normalizePlayedGameRows(games, categoryName);

            playedRows.forEach((row) => {
               const key = String(row.id || `${row.name}-${row.category}`);
               const prev = mergedMap.get(key);

               if (!prev) {
                  mergedMap.set(key, row);
                  return;
               }

               const prevDate = Moment(prev.lastPlayedAt);
               const rowDate = Moment(row.lastPlayedAt);

               mergedMap.set(key, {
                  ...prev,
                  bestScore: Math.max(Number(prev.bestScore || 0), Number(row.bestScore || 0)),
                  totalAttempts: Number(prev.totalAttempts || 0) + Number(row.totalAttempts || 0),
                  completedAttempts: Number(prev.completedAttempts || 0) + Number(row.completedAttempts || 0),
                  lastPlayedAt: rowDate.isValid() && (!prevDate.isValid() || rowDate.isAfter(prevDate))
                     ? row.lastPlayedAt
                     : prev.lastPlayedAt,
               });
            });
         });

         const sortedRows = Array.from(mergedMap.values()).sort((a, b) => {
            const aDate = Moment(a?.lastPlayedAt);
            const bDate = Moment(b?.lastPlayedAt);

            if (aDate.isValid() && bDate.isValid()) {
               return bDate.valueOf() - aDate.valueOf();
            }
            if (aDate.isValid()) return -1;
            if (bDate.isValid()) return 1;
            return String(a?.name || '').localeCompare(String(b?.name || ''));
         });

         setLearningGames(sortedRows);
      } catch (error) {
         console.error('Error fetching played games:', error);
         setLearningGames([]);
      } finally {
         setShowLearningLoader(false);
      }
   }

   async function getAssignedGames(overrideStudentId) {
      setAssignedGamesLoading(true);
      setAssignedGamesFetchAttempted(true);
      try {
         const assignedGamesStudentId = overrideStudentId ?? getEffectiveStudentId(profileData);
         const response = await apiHandler(TEACHERS_GET_ASSIGNED_GAMES_API, 'POST', {
            student_id: assignedGamesStudentId,
            user_id: assignedGamesStudentId,
         });
         if (response?.data?.response?.status === 200) {
            const assignedGamesList = response.data?.data?.assigned_games || [];
            setAssignedGames(assignedGamesList);
         } else {
            setAssignedGames([]);
         }
      } catch (error) {
         console.error('Error fetching assigned games:', error);
         setAssignedGames([]);
      } finally {
         setAssignedGamesLoading(false);
      }
   }

   function getAttendanceDateMoment(dateValue) {
      if (!dateValue) return null;
      const utcDate = Moment.utc(dateValue);
      if (utcDate.isValid()) return utcDate;
      const localDate = Moment(dateValue);
      return localDate.isValid() ? localDate : null;
   }

   function getAttendanceDateKey(dateValue) {
      const dateMoment = getAttendanceDateMoment(dateValue);
      return dateMoment ? dateMoment.format('YYYY-MM-DD') : '';
   }

   function formatAttendanceDate(dateValue, format = 'ddd, DD MMM YYYY') {
      const dateMoment = getAttendanceDateMoment(dateValue);
      return dateMoment ? dateMoment.format(format) : '-';
   }

   function getAttendanceSortValue(entry) {
      const dateKey = getAttendanceDateKey(entry?.attendance_date);
      if (!dateKey) return 0;

      const timeValue = entry?.attendance_time || '00:00:00';
      const dateTime = Moment(`${dateKey} ${timeValue}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);
      if (dateTime.isValid()) {
         return dateTime.valueOf();
      }

      const dateOnly = Moment(dateKey, 'YYYY-MM-DD', true);
      return dateOnly.isValid() ? dateOnly.valueOf() : 0;
   }

   async function getStudentAttendanceApi(targetMonth = attendanceSelectedMonth, overrideStudentId) {
      const selectedMonth = Moment(targetMonth).isValid()
         ? Moment(targetMonth).startOf('month')
         : Moment().startOf('month');
      const startDate = selectedMonth.clone().startOf('month').format('YYYY-MM-DD');
      const endDate = selectedMonth.clone().endOf('month').format('YYYY-MM-DD');

      setShowAttendanceLoader(true);
      setAttendanceFetchAttempted(true);

      try {
         const response = await apiHandler(STUDENT_ATTENDANCE_LIST_API, 'POST', {
            page: 1,
            limit: 20,
            start_date: startDate,
            end_date: endDate,
            student_id: overrideStudentId ?? getEffectiveStudentId(profileData),
         });

         if (response?.data?.response?.status === 200) {
            const attendanceData = response?.data?.data || {};
            const list = Array.isArray(attendanceData?.attendance_list) ? attendanceData.attendance_list : [];

            const sortedAttendance = [...list].sort((left, right) => {
               return getAttendanceSortValue(right) - getAttendanceSortValue(left);
            });

            setAttendanceList(sortedAttendance);
            setAttendanceStats(attendanceData?.statistics || null);
            setAttendanceSession(attendanceData?.session || null);
            setAttendanceStudent(attendanceData?.student || null);
         } else {
            setAttendanceList([]);
            setAttendanceStats(null);
            setAttendanceSession(null);
            setAttendanceStudent(null);
         }
      } catch (error) {
         console.error('Error fetching student attendance:', error);
         setAttendanceList([]);
         setAttendanceStats(null);
         setAttendanceSession(null);
         setAttendanceStudent(null);
      } finally {
         setShowAttendanceLoader(false);
      }
   }

   const handleAttendanceMonthChange = (direction) => {
      const nextMonth = Moment(attendanceSelectedMonth)
         .startOf('month')
         .add(direction, 'month');
      const minSessionMonth = attendanceSession?.start_date
         ? Moment(attendanceSession.start_date).startOf('month')
         : null;
      const maxSessionMonth = attendanceSession?.end_date
         ? Moment(attendanceSession.end_date).startOf('month')
         : null;

      if (minSessionMonth && nextMonth.isBefore(minSessionMonth, 'month')) {
         return;
      }

      if (maxSessionMonth && nextMonth.isAfter(maxSessionMonth, 'month')) {
         return;
      }

      setAttendanceSelectedMonth(nextMonth);
   };

   const attendanceMonthLabel = Moment(attendanceSelectedMonth).format('MMMM YYYY');
   const isAttendancePrevDisabled = attendanceSession?.start_date
      ? Moment(attendanceSelectedMonth).startOf('month').isSameOrBefore(Moment(attendanceSession.start_date).startOf('month'), 'month')
      : false;
   const isAttendanceNextDisabled = attendanceSession?.end_date
      ? Moment(attendanceSelectedMonth).startOf('month').isSameOrAfter(Moment(attendanceSession.end_date).startOf('month'), 'month')
      : false;

   const formatAttendancePercentage = (value) => {
      const numericValue = Number(value || 0);
      if (!Number.isFinite(numericValue)) return '0';
      if (Number.isInteger(numericValue)) return String(numericValue);
      return numericValue.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
   };

   const handleDailyReportDateFilter = () => {
      if (dailyReportStartDate && dailyReportEndDate && dailyReportStartDate > dailyReportEndDate) {
         Swal.fire({
            title: 'Invalid Date Range',
            text: 'Start date cannot be after end date.',
            icon: 'warning',
            confirmButtonText: 'OK'
         });
         return;
      }

      getDailyReportsList(dailyReportStartDate || null, dailyReportEndDate || null);
   };

   const clearDailyReportDateFilter = () => {
      setDailyReportStartDate('');
      setDailyReportEndDate('');
      getDailyReportsList();
   };

   const getDailyReportDateGroupLabel = (reportDate) => {
      const day = Moment(reportDate);
      if (!day.isValid()) return 'Unknown Date';
      const today = Moment().startOf('day');
      if (day.isSame(today, 'day')) return `Today | ${day.format('dddd, MMMM D')}`;
      if (day.isSame(today.clone().subtract(1, 'day'), 'day')) return `Yesterday | ${day.format('dddd, MMMM D')}`;
      return day.format('dddd, MMMM D');
   };

   const getDailyReportTimelineSummary = (report) => {
      if (report?.comments) return stripHtml(report.comments).slice(0, 140);
      if (report?.observation) return stripHtml(report.observation).slice(0, 140);
      if (report?.learned) return stripHtml(report.learned).slice(0, 140);
      return '';
   };

   const getDailyReportTimelineTitle = (report) => {
      if (report?.observation) return 'Observation note added';
      if (report?.comments) return 'Teacher comment updated';
      if (report?.daily_report_meals?.length > 0 && report?.daily_report_sleeps?.length > 0) return 'Daily care summary updated';
      if (report?.daily_report_meals?.length > 0) return 'Meal activity logged';
      if (report?.daily_report_sleeps?.length > 0) return 'Sleep activity logged';
      return 'Daily report submitted';
   };

   const getSleepDurationMinutes = (sleepEntry) => {
      const start = Moment(sleepEntry?.start_time, ['HH:mm:ss', 'HH:mm']);
      const end = Moment(sleepEntry?.end_time, ['HH:mm:ss', 'HH:mm']);
      if (!start.isValid() || !end.isValid()) return 0;
      return Math.max(end.diff(start, 'minutes'), 0);
   };

   const getDailyReportTimelineBadges = (report) => {
      const badges = [];
      const moods = report?.daily_report_fealings?.map((f) => f?.fealing?.name).filter(Boolean) || [];
      const meals = (report?.daily_report_meals || []).reduce((sum, group) => sum + (group?.items?.length || 0), 0);
      const sleeps = report?.daily_report_sleeps || [];
      const diapers = report?.daily_report_diapers?.length || 0;
      const totalSleepMinutes = sleeps.reduce((sum, entry) => sum + getSleepDurationMinutes(entry), 0);

      if (moods.length > 0) badges.push({ label: moods.slice(0, 2).join(', '), bg: '#fef3c7', color: '#92400e' });
      if (meals > 0) badges.push({ label: `${meals} meal${meals > 1 ? 's' : ''}`, bg: '#dcfce7', color: '#166534' });
      if (totalSleepMinutes > 0) {
         const hours = Math.floor(totalSleepMinutes / 60);
         const minutes = totalSleepMinutes % 60;
         badges.push({ label: `${hours > 0 ? `${hours}h ` : ''}${minutes}m sleep`, bg: '#dbeafe', color: '#1e3a8a' });
      }
      if (diapers > 0) badges.push({ label: `${diapers} diaper/toilet`, bg: '#ede9fe', color: '#6d28d9' });

      return badges.slice(0, 4);
   };

   const getDailyReportTimelineIcon = (report) => {
      if (report?.observation) return { icon: 'ri-sticky-note-line', bg: '#e0e7ff', color: '#3730a3' };
      if (report?.comments) return { icon: 'ri-chat-3-line', bg: '#fef3c7', color: '#92400e' };
      if (report?.daily_report_meals?.length > 0) return { icon: 'ri-restaurant-line', bg: '#bbf7d0', color: '#166534' };
      if (report?.daily_report_sleeps?.length > 0) return { icon: 'ri-zzz-line', bg: '#dbeafe', color: '#1e3a8a' };
      return { icon: 'ri-file-list-3-line', bg: '#e5e7eb', color: '#4b5563' };
   };

   const groupedDailyReports = dailyReportsList.reduce((groups, report) => {
      const dateKey = Moment(report?.report_date).isValid() ? Moment(report.report_date).format('YYYY-MM-DD') : `unknown-${report?.id || groups.length}`;
      const label = getDailyReportDateGroupLabel(report?.report_date);
      const lastGroup = groups[groups.length - 1];
      if (!lastGroup || lastGroup.dateKey !== dateKey) {
         groups.push({ dateKey, label, reports: [report] });
      } else {
         lastGroup.reports.push(report);
      }
      return groups;
   }, []);

   const isDaycareProfileView = Boolean(localStorage.getItem('uzoneAuthToken'));
   const timelineRows = Array.isArray(feedsList) ? feedsList.slice(0, 8) : [];
   const totalLearningCompletions = learningGames.reduce((sum, game) => sum + Number(game?.completedAttempts || 0), 0);
   const totalLearningAttempts = learningGames.reduce((sum, game) => sum + Number(game?.totalAttempts || 0), 0);
   const highestLearningScore = learningGames.reduce((max, game) => Math.max(max, Number(game?.bestScore || 0)), 0);
   const averageLearningScore = learningGames.length > 0
      ? Math.round(learningGames.reduce((sum, game) => sum + Number(game?.bestScore || 0), 0) / learningGames.length)
      : 0;
   const topLearningGame = learningGames.length > 0
      ? [...learningGames].sort((left, right) => {
         const scoreGap = Number(right?.bestScore || 0) - Number(left?.bestScore || 0);
         if (scoreGap !== 0) return scoreGap;
         return Number(right?.completedAttempts || 0) - Number(left?.completedAttempts || 0);
      })[0]
      : null;
   const recentLearningGames = [...learningGames].slice(0, 3);
   const learningCategories = Object.entries(
      learningGames.reduce((acc, game) => {
         const categoryName = game?.category || 'General';
         if (!acc[categoryName]) {
            acc[categoryName] = {
               label: categoryName,
               count: 0,
               completions: 0,
            };
         }

         acc[categoryName].count += 1;
         acc[categoryName].completions += Number(game?.completedAttempts || 0);
         return acc;
      }, {})
   )
      .map(([, value]) => value)
      .sort((left, right) => right.completions - left.completions)
      .slice(0, 4);
   const attendanceTotalDays = Number(attendanceStats?.total_days);
   const attendancePresentDays = Number(attendanceStats?.present_days);
   const attendanceAbsentDays = Number(attendanceStats?.absent_days);
   const attendancePercentage = Number(attendanceStats?.attendance_percentage);
   const hasApiAttendanceStats = [attendanceTotalDays, attendancePresentDays, attendanceAbsentDays, attendancePercentage]
      .every((value) => Number.isFinite(value));
   const fallbackAttendanceTotalDays = attendanceList.length;
   const fallbackAttendancePresentDays = attendanceList.filter((entry) => Number(entry?.status) === 1).length;
   const fallbackAttendanceAbsentDays = attendanceList.filter((entry) => Number(entry?.status) !== 1).length;
   const fallbackAttendancePercentage = fallbackAttendanceTotalDays > 0
      ? (fallbackAttendancePresentDays / fallbackAttendanceTotalDays) * 100
      : 0;
   const attendanceSummary = {
      totalDays: hasApiAttendanceStats ? attendanceTotalDays : fallbackAttendanceTotalDays,
      presentDays: hasApiAttendanceStats ? attendancePresentDays : fallbackAttendancePresentDays,
      absentDays: hasApiAttendanceStats ? attendanceAbsentDays : fallbackAttendanceAbsentDays,
      percentage: hasApiAttendanceStats ? attendancePercentage : fallbackAttendancePercentage,
   };
   const attendanceMonthStart = Moment(attendanceSelectedMonth).startOf('month');
   const attendanceMonthEnd = Moment(attendanceSelectedMonth).endOf('month');
   const attendanceMonthRangeLabel = `${attendanceMonthStart.format('DD MMM')} - ${attendanceMonthEnd.format('DD MMM YYYY')}`;
   const attendanceDaySummary = attendanceList.reduce((acc, entry) => {
      const dateKey = getAttendanceDateKey(entry?.attendance_date);
      if (!dateKey) {
         return acc;
      }

      const sortValue = getAttendanceSortValue(entry);
      if (!acc[dateKey] || sortValue > acc[dateKey].sortValue) {
         const isPresent = Number(entry?.status) === 1;
         acc[dateKey] = {
            sortValue,
            status: isPresent ? 'present' : 'absent',
            statusText: entry?.status_text || (isPresent ? 'Present' : 'Absent'),
         };
      }

      return acc;
   }, {});
   const attendanceMonthLeadingBlanks = attendanceMonthStart.day();
   const attendanceCalendarCells = Array.from({ length: attendanceMonthStart.daysInMonth() }, (_, index) => {
      const dayNumber = index + 1;
      const dayKey = attendanceMonthStart.clone().date(dayNumber).format('YYYY-MM-DD');
      const summary = attendanceDaySummary[dayKey] || null;
      let tone = { bg: '#f8fafc', border: '#e5e7eb', text: '#9ca3af' };

      if (summary?.status === 'present') {
         tone = { bg: '#dcfce7', border: '#86efac', text: '#166534' };
      } else if (summary?.status === 'absent') {
         tone = { bg: '#fee2e2', border: '#fecaca', text: '#b91c1c' };
      }

      return {
         key: dayKey,
         dayNumber,
         summary,
         tone,
      };
   });
   const attendanceCalendarGridItems = [
      ...Array.from({ length: attendanceMonthLeadingBlanks }, (_, index) => ({ key: `blank-${index}`, isBlank: true })),
      ...attendanceCalendarCells,
   ];
   const attendanceRecordedDays = Object.keys(attendanceDaySummary).length;
   const attendancePresentMarkedDays = Object.values(attendanceDaySummary).filter((day) => day?.status === 'present').length;
   const attendanceAbsentMarkedDays = Object.values(attendanceDaySummary).filter((day) => day?.status === 'absent').length;
   const attendanceUnmarkedDays = Math.max(attendanceMonthStart.daysInMonth() - attendanceRecordedDays, 0);

   if (isDaycareProfileView) {
      return (
         <div
            id='content-page'
            className='content-page'
            style={{
               paddingLeft: '12px',
               paddingRight: '12px'
            }}
         >
            <Container
               fluid
               style={{
                  marginTop: '12px',
                  paddingLeft: 0,
                  paddingRight: 0
               }}
            >
               <Card style={{ border: '1px solid #e8edf3', borderRadius: '12px', overflow: 'hidden' }}>
                  <div style={{ padding: '10px 16px', borderBottom: '1px solid #eceff3' }}>
                     <Row className='g-2 align-items-center'>
                        <Col md={7}>
                           <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                              <img
                                 src={displayProfile?.user_setting?.photo ? displayProfile?.user_setting?.photo : 'https://uzone360live.s3.amazonaws.com/noimage.png'}
                                 alt='profile'
                                 style={{ width: '42px', height: '42px', borderRadius: '50%', objectFit: 'cover' }}
                              />
                              <div style={{ minWidth: 0, flex: '1 1 220px' }}>
                                 <div style={{ fontSize: 'clamp(22px, 4vw, 34px)', lineHeight: 1.1, fontWeight: 700, color: '#1f2937', wordBreak: 'break-word' }}>
                                    {displayProfile?.first_name} {displayProfile?.last_name}
                                 </div>
                                 <div style={{ fontSize: 'clamp(12px, 2.2vw, 16px)', color: '#6b7280', marginTop: '4px', wordBreak: 'break-word' }}>
                                    {getAgeLabel(displayProfile?.user_setting?.dob)}{displayProfile?.user_teachers_and_room?.room?.room_name && (
                                       <> | <span style={{ color: 'var(--bs-warning)', fontWeight: 600 }}>{displayProfile?.user_teachers_and_room.room.room_name}</span></>
                                    )}
                                 </div>
                              </div>
                           </div>
                        </Col>
                        <Col md={5}>
                           <div style={{ display: 'flex', gap: '10px', justifyContent: isCompactViewport ? 'flex-start' : 'flex-end', flexWrap: 'wrap' }}>
                              <Button
                                 size='sm'
                                 style={{ 
                                    borderRadius: '50px', 
                                    whiteSpace: 'nowrap',
                                    border: '1px solid #d1d5db',
                                    color: '#374151',
                                    fontWeight: '500',
                                    fontSize: '12px',
                                    padding: '0px 10px',
                                    background: '#ffffff',
                                    transition: 'all 0.2s ease',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                    lineHeight: 1,
                                    height: '30px',
                                 }}
                                 onClick={() => navigate('/dashboard/app/user-profile-edit')}
                                 onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#9ca3af';
                                    e.currentTarget.style.background = '#f9fafb';
                                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                                 }}
                                 onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#d1d5db';
                                    e.currentTarget.style.background = '#ffffff';
                                    e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                                 }}
                              >
                                 <i className='ri-pencil-line' style={{ fontSize: '13px', lineHeight: 1 }}></i>
                                 <span style={{ lineHeight: 1 }}>{isActingAsParent(profileData) ? "Edit Child Profile" : "Edit Profile"}</span>
                              </Button>
                              <Button
                                 size='sm'
                                 style={{ 
                                    borderRadius: '50px', 
                                    whiteSpace: 'nowrap',
                                    border: '1px solid #d1d5db',
                                    color: '#374151',
                                    fontWeight: '500',
                                    fontSize: '12px',
                                    padding: '0px 10px',
                                    background: '#ffffff',
                                    transition: 'all 0.2s ease',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                    lineHeight: 1,
                                    height: '30px',
                                 }}
                                 onClick={() => {
                                    try {
                                       const settingStorageKey = 'socialvsetting-react';
                                       const settingSnapshot = sessionStorage.getItem(settingStorageKey) || localStorage.getItem(settingStorageKey);
                                       if (settingSnapshot) {
                                          localStorage.setItem(settingStorageKey, settingSnapshot);
                                       }
                                    } catch (error) {
                                       console.error('Unable to sync setting storage for chat tab:', error);
                                    }

                                    window.open('/chat/index', '_blank', 'noopener,noreferrer');
                                 }}
                                 onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#9ca3af';
                                    e.currentTarget.style.background = '#f9fafb';
                                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                                 }}
                                 onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#d1d5db';
                                    e.currentTarget.style.background = '#ffffff';
                                    e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                                 }}
                              >
                                 <i className='ri-chat-1-line' style={{ fontSize: '13px', lineHeight: 1 }}></i>
                                 <span style={{ lineHeight: 1 }}>Send message</span>
                              </Button>
                              {isSelfStudentProfileView(profileData) && (
                                 <Button
                                    size='sm'
                                    style={{
                                       borderRadius: '50px',
                                       whiteSpace: 'nowrap',
                                       border: '1px solid #d1d5db',
                                       color: '#374151',
                                       fontWeight: '500',
                                       fontSize: '12px',
                                       padding: '0px 10px',
                                       background: '#ffffff',
                                       transition: 'all 0.2s ease',
                                       display: 'inline-flex',
                                       alignItems: 'center',
                                       gap: '4px',
                                       boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                       lineHeight: 1,
                                       height: '30px',
                                    }}
                                    onClick={() => setShowInviteParentModal(true)}
                                    onMouseEnter={(e) => {
                                       e.currentTarget.style.borderColor = '#9ca3af';
                                       e.currentTarget.style.background = '#f9fafb';
                                       e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                       e.currentTarget.style.borderColor = '#d1d5db';
                                       e.currentTarget.style.background = '#ffffff';
                                       e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                                    }}
                                 >
                                    <i className='ri-user-add-line' style={{ fontSize: '13px', lineHeight: 1 }}></i>
                                    <span style={{ lineHeight: 1 }}>Send Parent Invitation</span>
                                 </Button>
                              )}
                           </div>
                        </Col>
                     </Row>
                     {isActingAsParent(profileData) && parentChildren.length > 1 && (() => {
                        const selectedChild = parentChildren.find((child) => String(child?.id) === String(getEffectiveStudentId(profileData))) || parentChildren[0];
                        const childAvatarFallback = 'https://uzone360live.s3.amazonaws.com/noimage.png';
                        return (
                           <Row className='g-2 align-items-center mt-2'>
                              <Col xs={12} md={6} lg={4}>
                                 <div
                                    ref={childDropdownToggleRef}
                                    role='button'
                                    tabIndex={0}
                                    aria-haspopup='listbox'
                                    aria-expanded={isChildDropdownOpen}
                                    aria-label='Viewing Child'
                                    onClick={() => setIsChildDropdownOpen((open) => !open)}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Enter' || e.key === ' ') {
                                          e.preventDefault();
                                          setIsChildDropdownOpen((open) => !open);
                                       }
                                    }}
                                    style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '8px',
                                       padding: '4px 12px 4px 6px',
                                       borderRadius: '50px',
                                       border: '1px solid #d1d5db',
                                       background: '#ffffff',
                                       boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                       transition: 'all 0.2s ease',
                                       cursor: 'pointer',
                                       userSelect: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                       e.currentTarget.style.borderColor = '#9ca3af';
                                       e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                       e.currentTarget.style.borderColor = '#d1d5db';
                                       e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                                    }}
                                 >
                                    <img
                                       src={selectedChild?.user_setting?.photo || childAvatarFallback}
                                       alt=''
                                       style={{ width: '26px', height: '26px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                    />
                                    <span style={{ fontSize: '11px', color: '#9ca3af', fontWeight: 600, whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                                       Viewing
                                    </span>
                                    <span style={{ fontSize: '13px', fontWeight: 700, color: '#1f2937', whiteSpace: 'nowrap' }}>
                                       {selectedChild?.first_name} {selectedChild?.last_name}
                                    </span>
                                    <i
                                       className='ri-arrow-down-s-line'
                                       style={{
                                          fontSize: '16px',
                                          color: '#9ca3af',
                                          marginLeft: 'auto',
                                          lineHeight: 1,
                                          transition: 'transform 0.2s ease',
                                          transform: isChildDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                       }}
                                    ></i>
                                 </div>

                                 {isChildDropdownOpen && childDropdownRect && createPortal(
                                    <div
                                       ref={childDropdownMenuRef}
                                       role='listbox'
                                       aria-label='Viewing Child options'
                                       style={{
                                          position: 'fixed',
                                          top: childDropdownRect.bottom + 6,
                                          left: childDropdownRect.left,
                                          minWidth: childDropdownRect.width,
                                          background: '#ffffff',
                                          border: '1px solid #e5e7eb',
                                          borderRadius: '12px',
                                          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
                                          padding: '6px',
                                          zIndex: 3000,
                                          maxHeight: '280px',
                                          overflowY: 'auto',
                                       }}
                                    >
                                       {parentChildren.map((child) => {
                                          const isSelected = String(child?.id) === String(getEffectiveStudentId(profileData));
                                          return (
                                             <div
                                                key={child?.id}
                                                role='option'
                                                aria-selected={isSelected}
                                                onClick={() => {
                                                   handleSelectChild(child?.id);
                                                   setIsChildDropdownOpen(false);
                                                }}
                                                style={{
                                                   display: 'flex',
                                                   alignItems: 'center',
                                                   gap: '10px',
                                                   padding: '8px 10px',
                                                   borderRadius: '8px',
                                                   cursor: 'pointer',
                                                   background: isSelected ? '#eef2ff' : 'transparent',
                                                   transition: 'background 0.15s ease',
                                                }}
                                                onMouseEnter={(e) => {
                                                   if (!isSelected) e.currentTarget.style.background = '#f3f4f6';
                                                }}
                                                onMouseLeave={(e) => {
                                                   if (!isSelected) e.currentTarget.style.background = 'transparent';
                                                }}
                                             >
                                                <img
                                                   src={child?.user_setting?.photo || childAvatarFallback}
                                                   alt=''
                                                   style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                                />
                                                <span style={{ fontSize: '13px', fontWeight: isSelected ? 700 : 500, color: '#1f2937', flex: 1 }}>
                                                   {child?.first_name} {child?.last_name}
                                                </span>
                                                {isSelected && <i className='ri-check-line' style={{ fontSize: '15px', color: '#4f46e5' }}></i>}
                                             </div>
                                          );
                                       })}
                                    </div>,
                                    document.body
                                 )}
                              </Col>
                           </Row>
                        );
                     })()}
                  </div>

                  <div style={{
                     padding: '0 16px',
                     borderBottom: '1px solid #eceff3',
                     overflowX: 'auto',
                     // Hints that the tab strip scrolls sideways (there are
                     // up to 10 tabs for a student profile, easily wider
                     // than any phone screen) by fading its own edges
                     // instead of clipping tab labels abruptly mid-word the
                     // way a plain overflow cut them off.
                     WebkitMaskImage: 'linear-gradient(to right, transparent, black 16px, black calc(100% - 16px), transparent)',
                     maskImage: 'linear-gradient(to right, transparent, black 16px, black calc(100% - 16px), transparent)',
                  }}>
                     <div style={{ display: 'flex', minWidth: 'max-content' }}>
                        {(() => {
                           // For students: show all tabs
                           const isStudent = isStudentLoginProfile(profileData);
                           // "Parent Access" is only meaningful on a student's own
                           // profile — a parent browsing their child's profile
                           // shouldn't manage that child's parent-access list.
                           // isSelfStudentProfileView additionally trusts
                           // getStoredParentStudentId() (the same signal apiHandler
                           // uses to scope every request) over user_type alone, so a
                           // parent session can't slip through this due to user_type
                           // not being populated yet on profileData.
                           const isStudentOwnProfile = isStudent && isSelfStudentProfileView(profileData);
                           const allTabs = ['Timeline', 'Daily report', 'About', 'Family', 'Media', 'Documents', 'Finance', 'Learning', 'Attendance', 'Registration Packet', ...(isStudentOwnProfile ? ['Parent Access'] : [])];
                           const restrictedTabs = ['Timeline', 'About', 'Media'];
                           
                           // Function to check if a tab has data
                           const hasTabData = (tab) => {
                              switch (tab) {
                                 case 'Timeline':
                                    return true; // Always show Timeline
                                 case 'Daily report':
                                    return dailyReportsList && dailyReportsList.length > 0;
                                 case 'About':
                                    return true; // Always show About
                                 case 'Family':
                                    return displayProfile?.user_setting?.fathers_name ||
                                           displayProfile?.user_setting?.mothers_name ||
                                           displayProfile?.user_setting?.guardian_name ||
                                           (displayProfile?.emergency_contacts && displayProfile?.emergency_contacts.length > 0);
                                 case 'Media':
                                    return (galleryImageList && galleryImageList.length > 0) ||
                                           (galleryVideoList && galleryVideoList.length > 0);
                                 case 'Documents':
                                    return displayProfile?.lunch_plan_waiver ||
                                           displayProfile?.allergy_action_plan ||
                                           displayProfile?.no_peanut_policy;
                                 case 'Finance':
                                    return gradeTransactions && gradeTransactions.length > 0;
                                 case 'Learning':
                                    return true; // Can be customized based on learning data
                                 case 'Attendance':
                                    return true; // Always show for students
                                 case 'Registration Packet':
                                    return true; // Always show for students
                                 case 'Parent Access':
                                    return true; // Always show on a student's own profile
                                 default:
                                    return false;
                              }
                           };
                           
                           const tabsToShow = isStudent ? allTabs : restrictedTabs;
                           const visibleTabs = isStudent ? tabsToShow : tabsToShow.filter(tab => hasTabData(tab));
                           
                           return visibleTabs.map((tab) => (
                           <button
                              key={tab}
                              type='button'
                              data-daycare-tab={tab}
                              onClick={() => setDaycareActiveTab(tab)}
                              style={{
                                 position: 'relative',
                                 border: 'none',
                                 background: 'transparent',
                                 borderBottom: daycareActiveTab === tab ? '2px solid var(--bs-warning)' : '2px solid transparent',
                                 color: daycareActiveTab === tab ? 'var(--bs-warning)' : '#6b7280',
                                 fontSize: '13px',
                                 fontWeight: 600,
                                 padding: '10px 12px'
                              }}
                           >
                              {tab}
                              {tab === 'Registration Packet' && registrationPacketIncomplete && (
                                 <span style={{
                                    position: 'absolute',
                                    top: '6px',
                                    right: '4px',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: 'red',
                                    animation: 'blinker 1s linear infinite',
                                    display: 'inline-block'
                                 }}></span>
                              )}
                           </button>
                        ));
                        })()}
                     </div>
                  </div>

                  {daycareActiveTab === 'Timeline' ? (
                     <div style={{ padding: '16px', background: 'linear-gradient(180deg, #fafbfc 0%, #f4f8ff 100%)' }}>
                        <Row className='g-3'>
                           <Col lg={4}>
                              {/* Stories — own/student only */}
                              {(profileData?.user_type !== 2 && profileData?.user_type !== 4) && (
                                 <StoriesSection isMyStory={true} />
                              )}

                              {/* Photos */}
                              <GalleryImageCard userId={getEffectiveStudentId(profileData)} />

                              {followerList.length > 0 && (
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                    <div className='card-header d-flex justify-content-between'>
                                       <div className='header-title'>
                                          <h6 className='card-title mb-0'>Followers</h6>
                                       </div>
                                       <div className='card-header-toolbar d-flex align-items-center'>
                                          <p className='m-0'><Link to='/dashboards/app/follower-list'>View All</Link></p>
                                       </div>
                                    </div>
                                    <Card.Body>
                                       <ul className='profile-img-gallary p-0 m-0 list-unstyled'>
                                          {followerList.map((elm) => (
                                             <li key={elm?.id}>
                                                <Link to={`/dashboard/app/friend-profile/${elm?.follower?.slug}`}>
                                                   <img
                                                      loading='lazy'
                                                      src={elm?.follower?.user_setting?.photo ? elm?.follower?.user_setting?.photo : 'https://uzone360live.s3.amazonaws.com/noimage.png'}
                                                      alt='follower'
                                                      className='img-fluid'
                                                   />
                                                </Link>
                                                <h6 className='mt-2 text-center'>{elm?.follower?.first_name && (elm?.follower?.first_name + ' ' + elm?.follower?.last_name)}</h6>
                                             </li>
                                          ))}
                                       </ul>
                                    </Card.Body>
                                 </Card>
                              )}

                              {followingList.length > 0 && (
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                    <div className='card-header d-flex justify-content-between'>
                                       <div className='header-title'>
                                          <h6 className='card-title mb-0'>Following</h6>
                                       </div>
                                       <div className='card-header-toolbar d-flex align-items-center'>
                                          <p className='m-0'><Link to='/dashboards/app/following-list'>View All</Link></p>
                                       </div>
                                    </div>
                                    <Card.Body>
                                       <ul className='profile-img-gallary p-0 m-0 list-unstyled'>
                                          {followingList.map((elm) => (
                                             <li key={elm?.id}>
                                                <Link to={`/dashboard/app/friend-profile/${elm?.following?.slug}`}>
                                                   <img
                                                      loading='lazy'
                                                      src={elm?.following?.user_setting?.photo ? elm?.following?.user_setting?.photo : 'https://uzone360live.s3.amazonaws.com/noimage.png'}
                                                      alt='following'
                                                      className='img-fluid'
                                                   />
                                                </Link>
                                                <h6 className='mt-2 text-center'>{elm?.following?.first_name && (elm?.following?.first_name + ' ' + elm?.following?.last_name)}</h6>
                                             </li>
                                          ))}
                                       </ul>
                                    </Card.Body>
                                 </Card>
                              )}
                           </Col>

                           <Col lg={8}>
                              {/* Create Post — own/student only */}
                              {(profileData?.user_type !== 2 && profileData?.user_type !== 4) && (
                                 <CreatePostInputBox
                                    postType={'0'}
                                    refreshApi={refreshApi}
                                    eventId={''}
                                 />
                              )}

                              {feedsList?.length > 0 ? feedsList.map((elm) => (
                                 <FeedPostCard elm={elm} getFeedsList={refreshApi} key={elm?.id} feedDetails={false} />
                              )) : <NoDataFound />}

                              {showMoreDataLoader && (
                                 <div className='col-sm-12 text-center'>
                                    <img src={loader} alt='loader' style={{ height: '100px' }} />
                                 </div>
                              )}
                              <InView as='div' onChange={(inView) => loadMore(inView)} />
                           </Col>
                        </Row>
                     </div>
                  ) : daycareActiveTab === 'Daily report' ? (
                     <div style={{ padding: '12px 16px', background: '#fafbfc' }}>
                        <Row className='g-3'>
                           <Col xs={12} style={{ minWidth: 0 }}>
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                 <Card.Body style={{ padding: 0 }}>
                                    <div style={{ padding: '12px' }}>
                                       <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #edf1f5' }}>
                                          <div style={{ fontWeight: 700, color: '#374151', marginBottom: '8px' }}>Filter by Date Range</div>
                                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'end' }}>
                                             <div style={{ minWidth: '190px', flex: '1 1 190px' }}>
                                                <Form.Label className='small text-muted mb-1'>Start Date</Form.Label>
                                                <Form.Control
                                                   type='date'
                                                   value={dailyReportStartDate}
                                                   onChange={(e) => setDailyReportStartDate(e.target.value)}
                                                />
                                             </div>
                                             <div style={{ minWidth: '190px', flex: '1 1 190px' }}>
                                                <Form.Label className='small text-muted mb-1'>End Date</Form.Label>
                                                <Form.Control
                                                   type='date'
                                                   value={dailyReportEndDate}
                                                   min={dailyReportStartDate || undefined}
                                                   onChange={(e) => setDailyReportEndDate(e.target.value)}
                                                />
                                             </div>
                                             <Button
                                                variant='primary'
                                                onClick={handleDailyReportDateFilter}
                                                disabled={showDailyReportLoader}
                                             >
                                                <i className='ri-search-line'></i>
                                             </Button>
                                             {(dailyReportStartDate || dailyReportEndDate) && (
                                                <Button
                                                   variant='outline-secondary'
                                                   onClick={clearDailyReportDateFilter}
                                                   disabled={showDailyReportLoader}
                                                >
                                                   <i className='ri-close-line'></i>
                                                </Button>
                                             )}
                                          </div>
                                       </div>

                                       <div>
                                          {showDailyReportLoader ? (
                                             <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                                <span className='spinner-border spinner-border-sm me-2'></span>
                                                Loading reports...
                                             </div>
                                          ) : dailyReportsList.length > 0 ? (
                                             <div>
                                                {groupedDailyReports.map((group, groupIndex) => (
                                                   <div key={`${group.dateKey}-${groupIndex}`} style={{ marginBottom: '14px' }}>
                                                      <div style={{
                                                         display: 'inline-block',
                                                         padding: '4px 10px',
                                                         borderRadius: '999px',
                                                         background: '#d1d5db',
                                                         color: '#ffffff',
                                                         fontSize: '11px',
                                                         fontWeight: 700,
                                                         marginBottom: '8px'
                                                      }}>
                                                         {group.label}
                                                      </div>

                                                      <div style={{ paddingLeft: '4px' }}>
                                                         {group.reports.map((report, itemIndex) => {
                                                            const iconMeta = getDailyReportTimelineIcon(report);
                                                            const summaryText = getDailyReportTimelineSummary(report);
                                                            const eventTitle = getDailyReportTimelineTitle(report);
                                                            const badges = getDailyReportTimelineBadges(report);
                                                            const moodText = report?.daily_report_fealings?.map((f) => f?.fealing?.name).filter(Boolean).join(', ');
                                                            const flatMealItems = (report?.daily_report_meals || []).flatMap((group) => (group?.items || []).map((item) => ({ ...item, menu_type: item?.menu_type || group?.menu_type })));
                                                            const mealRows = flatMealItems.slice(0, 3);
                                                            const sleepRows = (report?.daily_report_sleeps || []).slice(0, 3);
                                                            const diaperRows = (report?.daily_report_diapers || []).slice(0, 3);
                                                            const bringMoreRows = (report?.daily_report_bring_mores || []).slice(0, 4);
                                                            const eventTime = Moment(report?.created_at || report?.updated_at || report?.report_date).format('h:mm A');
                                                            const isLastItem = itemIndex === group.reports.length - 1;

                                                            return (
                                                               <div key={report?.id || `${group.dateKey}-${itemIndex}`} style={{ position: 'relative', paddingLeft: '34px', paddingBottom: isLastItem ? '2px' : '14px' }}>
                                                                  {!isLastItem && (
                                                                     <span style={{ position: 'absolute', left: '10px', top: '22px', bottom: '-4px', width: '2px', background: '#e5e7eb' }}></span>
                                                                  )}
                                                                  <span style={{
                                                                     position: 'absolute',
                                                                     left: 0,
                                                                     top: 0,
                                                                     width: '22px',
                                                                     height: '22px',
                                                                     borderRadius: '50%',
                                                                     background: iconMeta.bg,
                                                                     color: iconMeta.color,
                                                                     display: 'inline-flex',
                                                                     alignItems: 'center',
                                                                     justifyContent: 'center',
                                                                     fontSize: '12px'
                                                                  }}>
                                                                     <i className={iconMeta.icon}></i>
                                                                  </span>

                                                                  <div
                                                                     onClick={() => navigate(`/dashboard/app/student-dashboard?reportId=${report?.id}`)}
                                                                     style={{
                                                                        background: '#ffffff',
                                                                        border: '1px solid #edf1f5',
                                                                        borderRadius: '10px',
                                                                        padding: '10px 12px',
                                                                        boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
                                                                        cursor: 'pointer',
                                                                        transition: 'box-shadow 0.15s, border-color 0.15s',
                                                                     }}
                                                                     onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 3px 10px rgba(92,81,139,0.13)'; e.currentTarget.style.borderColor = '#c4b8f0'; }}
                                                                     onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 2px rgba(15,23,42,0.04)'; e.currentTarget.style.borderColor = '#edf1f5'; }}
                                                                  >
                                                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: '8px' }}>
                                                                        <div style={{ minWidth: 0 }}>
                                                                           <div style={{ fontSize: '12px', fontWeight: 700, color: '#374151', lineHeight: 1.35 }}>
                                                                              {displayProfile?.first_name || 'Student'} {eventTitle}
                                                                           </div>
                                                                           <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>
                                                                              {eventTime} | Report #{report?.id}
                                                                           </div>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                           <div style={{ fontSize: '10px', color: '#9ca3af', whiteSpace: 'nowrap' }}>
                                                                              {Moment(report?.report_date).format('MMM D')}
                                                                           </div>
                                                                           <i className='ri-arrow-right-s-line' style={{ color: '#9ca3af', fontSize: '14px' }}></i>
                                                                        </div>
                                                                     </div>

                                                                     {badges.length > 0 && (
                                                                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
                                                                           {badges.map((badge, badgeIndex) => (
                                                                              <span key={`${report?.id || itemIndex}-badge-${badgeIndex}`} style={{
                                                                                 padding: '2px 8px',
                                                                                 borderRadius: '999px',
                                                                                 fontSize: '10px',
                                                                                 fontWeight: 700,
                                                                                 background: badge.bg,
                                                                                 color: badge.color
                                                                              }}>
                                                                                 {badge.label}
                                                                              </span>
                                                                           ))}
                                                                        </div>
                                                                     )}

                                                                     {summaryText && (
                                                                        <div style={{ fontSize: '11px', color: '#4b5563', marginTop: '8px', lineHeight: 1.4 }}>
                                                                           {summaryText}
                                                                        </div>
                                                                     )}

                                                                     {(moodText || mealRows.length > 0 || sleepRows.length > 0 || diaperRows.length > 0 || bringMoreRows.length > 0) && (
                                                                        <div style={{ marginTop: '10px', borderTop: '1px dashed #e5e7eb', paddingTop: '8px', display: 'grid', gap: '5px' }}>
                                                                           {moodText && (
                                                                              <div style={{ fontSize: '11px', color: '#374151' }}>
                                                                                 <strong>Mood:</strong> {moodText}
                                                                              </div>
                                                                           )}

                                                                           {mealRows.length > 0 && (
                                                                              <div style={{ fontSize: '11px', color: '#374151' }}>
                                                                                 <strong>Meals:</strong>{' '}
                                                                                 {mealRows.map((meal, mealIndex) => `${meal?.menu_name || meal?.menu_type || 'Meal'} (${getMealAmountLabel(meal?.meal_amount)}) at ${formatTime(meal?.meal_time)}`).join(', ')}
                                                                                 {flatMealItems.length > 3 ? ` +${flatMealItems.length - 3} more` : ''}
                                                                              </div>
                                                                           )}

                                                                           {sleepRows.length > 0 && (
                                                                              <div style={{ fontSize: '11px', color: '#374151' }}>
                                                                                 <strong>Sleep:</strong>{' '}
                                                                                 {sleepRows.map((sleep) => `${formatTime(sleep?.start_time)} - ${formatTime(sleep?.end_time)}`).join(', ')}
                                                                                 {report?.daily_report_sleeps?.length > 3 ? ` +${report.daily_report_sleeps.length - 3} more` : ''}
                                                                              </div>
                                                                           )}

                                                                           {diaperRows.length > 0 && (
                                                                              <div style={{ fontSize: '11px', color: '#374151' }}>
                                                                                 <strong>Diaper/Toilet:</strong>{' '}
                                                                                 {diaperRows.map((d) => `${formatTime(d?.diaper_time)} (${d?.diaper_check === 1 ? 'D/T' : d?.diaper_check === 2 ? 'Dry' : d?.diaper_check === 3 ? 'Wet' : 'BM'})`).join(', ')}
                                                                                 {report?.daily_report_diapers?.length > 3 ? ` +${report.daily_report_diapers.length - 3} more` : ''}
                                                                              </div>
                                                                           )}

                                                                           {bringMoreRows.length > 0 && (
                                                                              <div style={{ fontSize: '11px', color: '#374151' }}>
                                                                                 <strong>Bring more:</strong>{' '}
                                                                                 {bringMoreRows.map((item) => {
                                                                                    const names = { 1: 'Diapers', 2: 'Wipes', 3: 'Ointment', 4: 'Clothes', 5: 'Blanket', 6: item?.other || 'Other' };
                                                                                    return names[item?.things] || 'Item';
                                                                                 }).join(', ')}
                                                                                 {report?.daily_report_bring_mores?.length > 4 ? ` +${report.daily_report_bring_mores.length - 4} more` : ''}
                                                                              </div>
                                                                           )}
                                                                        </div>
                                                                     )}
                                                                  </div>
                                                               </div>
                                                            );
                                                         })}
                                                      </div>
                                                   </div>
                                                ))}
                                             </div>
                                          ) : (
                                             <div style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>No daily reports available.</div>
                                          )}
                                       </div>
                                    </div>
                                 </Card.Body>
                              </Card>
                           </Col>
                        </Row>
                     </div>
                  ) : daycareActiveTab === 'Registration Packet' ? (
                     <div style={{ padding: '16px' }}>
                        {/* Handbook Section */}
                        {generalSettingsData?.handbook && (
                           <Card className='mb-4'>
                              <Card.Header className='d-flex align-items-center justify-content-between'>
                                 <div className='header-title'>
                                    <h4 className='card-title mb-0'>
                                       <i className='material-symbols-outlined me-2' style={{ verticalAlign: 'middle' }}>menu_book</i>
                                       Parent Handbook
                                    </h4>
                                 </div>
                              </Card.Header>
                              <Card.Body>
                                 <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
                                    <div>
                                       <p className='mb-2'>View or download our comprehensive parent handbook with all the information you need.</p>
                                       <small className='text-muted'>This handbook contains important policies, procedures, and guidelines.</small>
                                    </div>
                                    <Button
                                       variant='primary'
                                       href={generalSettingsData.handbook}
                                       target='_blank'
                                       rel='noopener noreferrer'
                                       className='d-flex align-items-center'
                                    >
                                       <i className='material-symbols-outlined me-2'>picture_as_pdf</i>
                                       View Handbook
                                    </Button>
                                 </div>
                              </Card.Body>
                           </Card>
                        )}

                        <Suspense fallback={<div className='text-center p-4'><span className='spinner-border spinner-border-sm me-2'></span>Loading...</div>}>
                           {(() => {
                              const regUser = displayProfile;

                              // "there's a submitted record" uses the same rule the standalone
                              // /dashboard/child-registration/list page and each *ListComp use:
                              // status === 1 (or, for Child Registration specifically, status
                              // === 3 too — matching the "Active" badge ChildRegistrationListComp
                              // already shows for those records).
                              const childRegActiveData = filterActiveRecords(childRegistrationData, isChildRegistrationRecordFilled);
                              // Falls back to the contacts profile/details now embeds, so an
                              // empty EMERGENCY_CONTACTS_LIST response doesn't show the "add"
                              // form to someone who already has active contacts on file.
                              const fetchedEmergencyContactActiveData = filterActiveRecords(emergencyContactsData);
                              const emergencyContactActiveData = fetchedEmergencyContactActiveData.length > 0
                                 ? fetchedEmergencyContactActiveData
                                 : filterActiveRecords(regUser?.emergency_contacts);

                              // Allergy Action Plan / Lunch Plan Waiver / No Peanut Policy are no
                              // longer their own steps below - ChildRegistrationFormComp now
                              // collects (and, once one exists, pre-fills/edits) all 3 inline as
                              // part of the Child Registration form itself, so a separate "fill
                              // this in" card for each here would just be a duplicate entry point
                              // for the same data. Because of that, the Child Registration step's
                              // own Form-vs-List choice can no longer be "is there a Child
                              // Registration record" alone: ChildRegistrationListComp only shows
                              // Child Registration's own fields, not those 3 sections, so
                              // switching to it as soon as the core record exists would hide the
                              // only place left to finish (or review) them. It only switches once
                              // the whole packet - Child Registration AND all 3 embedded sections
                              // - is filled.
                              const isPacketFullyFilled = childRegActiveData.length > 0 &&
                                 isEmbeddedStepFilled(regUser?.allergy_action_plan) &&
                                 isEmbeddedStepFilled(regUser?.lunch_plan_waiver) &&
                                 isEmbeddedStepFilled(regUser?.no_peanut_policy);

                              const regSteps = [
                                 {
                                    label: 'Child Registration',
                                    Form: ChildRegistrationFormComp,
                                    List: (props) => <ChildRegistrationListComp {...props} viewMode='profile' />,
                                    activeData: childRegActiveData,
                                    showList: isPacketFullyFilled,
                                    onSubmit: getProfileDetails
                                 },
                                 {
                                    label: 'Emergency Contact',
                                    Form: EmergencyContactFormComp,
                                    List: (props) => <EmergencyContactListComp {...props} viewMode='profile' />,
                                    activeData: emergencyContactActiveData,
                                    showList: emergencyContactActiveData.length > 0,
                                    onSubmit: handleEmergencyContactSubmit
                                 }
                              ];

                              // Whole-packet completeness (drives the banner below) still counts
                              // all 5 pieces via the same shared registrationPacketStatus helper
                              // the tab's red dot and the header banner use - instead of trusting
                              // displayProfile.is_registration_complete, a backend aggregate flag
                              // that was found stale (still reporting incomplete right after all
                              // forms had genuinely been filled in). Unaffected by the 3 sections
                              // no longer being separate steps above: they're still their own
                              // dedicated records underneath, this just changes where their entry
                              // point is shown.
                              // Same "don't trust it until it's actually been fetched" gate as the
                              // tab's red dot above - without it this banner briefly claims the
                              // packet is incomplete on every load, against each slice's empty
                              // initial state, before the real fetch lands.
                              const isRegistrationComplete = !(childRegistrationInitialized && emergencyContactsInitialized)
                                 || isRegistrationPacketComplete(getRegistrationPacketSteps({
                                 childRegistrationData,
                                 profile: regUser,
                                 emergencyContactsData
                              }));

                              return (
                                 <div>
                                    {/* Once every step has a submitted record, the list below already
                                        makes that obvious — the "Completed" banner was just repeating
                                        it as an announcement, so it's only shown while there's still
                                        something to act on. */}
                                    {!isRegistrationComplete && (
                                       <div className='alert alert-warning mb-4'>
                                          <i className='ri-error-warning-line me-2'></i>
                                          <strong>Registration Incomplete!</strong> Please complete all registration forms below.
                                       </div>
                                    )}
                                    {regSteps.map((step, idx) => (
                                       <div key={idx} className='mb-4 p-3 border rounded bg-light'>
                                          <h5 className='mb-3'>{step.label}</h5>
                                          {step.showList ? step.List({ data: step.activeData }) : <step.Form onSubmit={step.onSubmit} />}
                                       </div>
                                    ))}
                                 </div>
                              );
                           })()}
                        </Suspense>
                     </div>
                  ) : daycareActiveTab === 'About' ? (
                     <div style={{ padding: '16px' }}>
                        <Row className='g-3'>
                           {/* Personal Info */}
                           <Col md={6}>
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                 <Card.Body>
                                    <h6 style={{ color: '#d97745', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                       <i className='ri-user-line me-2'></i>Personal Information
                                    </h6>
                                    {[
                                       { label: 'Full Name', value: `${displayProfile?.first_name || ''} ${displayProfile?.last_name || ''}`.trim() },
                                       { label: 'Email', value: displayProfile?.email },
                                       { label: 'Mobile', value: displayProfile?.user_setting?.mobile_no || null },
                                       { label: 'Date of Birth', value: displayProfile?.user_setting?.dob ? Moment(displayProfile.user_setting.dob).format('MMMM DD, YYYY') : null },
                                       { label: 'Age', value: getAgeLabel(displayProfile?.user_setting?.dob) },
                                       { label: 'Gender', value: displayProfile?.user_setting?.gender === 0 || displayProfile?.user_setting?.gender === '0' ? 'Male' : displayProfile?.user_setting?.gender === 1 || displayProfile?.user_setting?.gender === '1' ? 'Female' : 'Other' },
                                       { label: 'Address', value: displayProfile?.user_setting?.address },
                                       { label: 'Bio', value: displayProfile?.user_setting?.bio },
                                       { label: 'Website', value: displayProfile?.user_setting?.website },
                                    ].filter(row => row.value).map(row => (
                                       <div key={row.label} style={{ display: 'flex', gap: '8px', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #f3f4f6' }}>
                                          <div style={{ minWidth: '130px', fontSize: '12px', color: '#6b7280', fontWeight: 600 }}>{row.label}</div>
                                          <div style={{ fontSize: '13px', color: '#1f2937', wordBreak: 'break-word' }}>{row.value}</div>
                                       </div>
                                    ))}
                                 </Card.Body>
                              </Card>
                           </Col>

                           {/* Health & Medical */}
                           <Col md={6}>
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                 <Card.Body>
                                    <h6 style={{ color: '#ef4444', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                       <i className='ri-heart-pulse-line me-2'></i>Health & Medical
                                    </h6>
                                    {[
                                       { label: 'Allergies', value: displayProfile?.user_setting?.allergies },
                                       { label: 'Medical Conditions', value: displayProfile?.user_setting?.medical_conditions },
                                       { label: "Doctor's Name", value: displayProfile?.user_setting?.doctors_name },
                                       { label: "Doctor's Phone", value: displayProfile?.user_setting?.doctors_phone },
                                       { label: 'Immunization Record', value: displayProfile?.user_setting?.immunization_record },
                                       { label: 'Health Insurance', value: displayProfile?.user_setting?.health_insurance_provider },
                                       { label: 'Special Needs / Remarks', value: displayProfile?.user_setting?.special_needs_or_remarks },
                                       { label: 'Notes', value: displayProfile?.user_setting?.notes },
                                    ].filter(row => row.value).map(row => (
                                       <div key={row.label} style={{ display: 'flex', gap: '8px', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #f3f4f6' }}>
                                          <div style={{ minWidth: '150px', fontSize: '12px', color: '#6b7280', fontWeight: 600 }}>{row.label}</div>
                                          <div style={{ fontSize: '13px', color: '#1f2937', wordBreak: 'break-word' }}>{row.value}</div>
                                       </div>
                                    ))}
                                    {!displayProfile?.user_setting?.allergies && !displayProfile?.user_setting?.medical_conditions && !displayProfile?.user_setting?.doctors_name && (
                                       <div style={{ color: '#9ca3af', fontSize: '13px' }}>No health information on file.</div>
                                    )}
                                 </Card.Body>
                              </Card>
                           </Col>

                           {/* Primary emergency contact from user_setting */}
                           {(displayProfile?.user_setting?.emergency_contact_name || displayProfile?.user_setting?.emergency_contact_number) && (
                              <Col md={12}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                    <Card.Body>
                                       <h6 style={{ color: '#f59e0b', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                          <i className='ri-alarm-warning-line me-2'></i>Primary Emergency Contact
                                       </h6>
                                       <Row className='g-3'>
                                          {[
                                             { label: 'Name', value: displayProfile?.user_setting?.emergency_contact_name },
                                             { label: 'Relationship', value: displayProfile?.user_setting?.emergency_relationship },
                                             { label: 'Phone', value: displayProfile?.user_setting?.emergency_contact_number },
                                             { label: 'Alternate Phone', value: displayProfile?.user_setting?.emergency_alternate_number },
                                             { label: 'Address', value: displayProfile?.user_setting?.emergency_address },
                                          ].filter(row => row.value).map(row => (
                                             <Col md={4} key={row.label}>
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600, marginBottom: '2px' }}>{row.label}</div>
                                                <div style={{ fontSize: '13px', color: '#1f2937' }}>{row.value}</div>
                                             </Col>
                                          ))}
                                       </Row>
                                    </Card.Body>
                                 </Card>
                              </Col>
                           )}
                        </Row>
                     </div>
                  ) : daycareActiveTab === 'Media' ? (
                     <div style={{ padding: '16px' }}>
                        <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                           <Card.Body>
                              <Tab.Container defaultActiveKey='media-photos'>
                                 <div className='friend-list-tab mt-2'>
                                    <Nav variant='pills' className='d-flex align-items-center justify-content-left friend-list-items p-0 mb-3'>
                                       <Nav.Item>
                                          <Nav.Link eventKey='media-photos'>Photos</Nav.Link>
                                       </Nav.Item>
                                       <Nav.Item>
                                          <Nav.Link eventKey='media-videos'>Videos</Nav.Link>
                                       </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                       <Tab.Pane eventKey='media-photos'>
                                          <GalleryImage galleryImageList={galleryImageList} />
                                       </Tab.Pane>
                                       <Tab.Pane eventKey='media-videos'>
                                          <GalleryVideo galleryVideoList={galleryVideoList} />
                                       </Tab.Pane>
                                    </Tab.Content>
                                 </div>
                              </Tab.Container>
                           </Card.Body>
                        </Card>
                     </div>
                  ) : daycareActiveTab === 'Family' ? (
                     <div style={{ padding: '16px' }}>
                        <Row className='g-3'>
                           {/* Father */}
                           {displayProfile?.user_setting?.fathers_name && (
                              <Col md={4}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                    <Card.Body>
                                       <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                                          <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-men-line' style={{ color: '#0d6efd', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '15px' }}>{displayProfile.user_setting.fathers_name}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Father</div>
                                          </div>
                                       </div>
                                       {displayProfile.user_setting.fathers_occupation && (
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#374151' }}>
                                             <i className='ri-briefcase-line' style={{ color: '#6b7280' }}></i>
                                             {displayProfile.user_setting.fathers_occupation}
                                          </div>
                                       )}
                                    </Card.Body>
                                 </Card>
                              </Col>
                           )}

                           {/* Mother */}
                           {displayProfile?.user_setting?.mothers_name && (
                              <Col md={4}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                    <Card.Body>
                                       <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                                          <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#fdf2f8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-women-line' style={{ color: '#db2777', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '15px' }}>{displayProfile.user_setting.mothers_name}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Mother</div>
                                          </div>
                                       </div>
                                       {displayProfile.user_setting.mothers_occupation && (
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#374151' }}>
                                             <i className='ri-briefcase-line' style={{ color: '#6b7280' }}></i>
                                             {displayProfile.user_setting.mothers_occupation}
                                          </div>
                                       )}
                                    </Card.Body>
                                 </Card>
                              </Col>
                           )}

                           {/* Guardian (only if different from father) */}
                           {displayProfile?.user_setting?.guardian_name && displayProfile?.user_setting?.guardian_name !== displayProfile?.user_setting?.fathers_name && (
                              <Col md={4}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                    <Card.Body>
                                       <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                                          <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-shield-user-line' style={{ color: '#16a34a', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '15px' }}>{displayProfile.user_setting.guardian_name}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Guardian · {displayProfile.user_setting.guardian_relationship}</div>
                                          </div>
                                       </div>
                                    </Card.Body>
                                 </Card>
                              </Col>
                           )}

                           {/* Emergency Contacts list */}
                           <Col md={12}>
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                 <Card.Body>
                                    <h6 style={{ color: '#f59e0b', fontWeight: 700, marginBottom: '16px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                       <i className='ri-alarm-warning-line me-2'></i>Emergency Contacts
                                    </h6>
                                    {familyEmergencyContacts.length > 0 ? (
                                       <Row className='g-3'>
                                          {familyEmergencyContacts.map((contact, idx) => (
                                             <Col md={4} key={contact.id ?? idx}>
                                                <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '14px' }}>
                                                   <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                                      <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#fff7ed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                         <i className='ri-user-line' style={{ color: '#f59e0b', fontSize: '16px' }}></i>
                                                      </div>
                                                      <div>
                                                         <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '14px' }}>{contact.contact_name}</div>
                                                         <div style={{ fontSize: '11px', color: '#6b7280' }}>{contact.relation}</div>
                                                      </div>
                                                   </div>
                                                   <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                                                      <i className='ri-phone-line' style={{ color: '#6b7280', fontSize: '13px' }}></i>
                                                      <span style={{ fontSize: '13px', color: '#374151' }}>{contact.phone}</span>
                                                   </div>
                                                   <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '12px', background: contact.status === 1 ? '#dcfce7' : '#fee2e2', color: contact.status === 1 ? '#16a34a' : '#dc2626', fontWeight: 600 }}>
                                                      {contact.status === 1 ? 'Active' : 'Inactive'}
                                                   </span>
                                                </div>
                                             </Col>
                                          ))}
                                       </Row>
                                    ) : (
                                       <div style={{ color: '#9ca3af', fontSize: '13px' }}>No emergency contacts on file.</div>
                                    )}
                                 </Card.Body>
                              </Card>
                           </Col>
                        </Row>
                     </div>
                  ) : daycareActiveTab === 'Finance' ? (
                     <div style={{ padding: '16px', background: 'linear-gradient(180deg, #f7faff 0%, #f9fafb 100%)' }}>
                        <Card style={{ border: '1px solid #e5e7eb', borderRadius: '10px' }}>
                           <Card.Body style={{ padding: '12px' }}>
                              <div style={{ borderBottom: '1px solid #eceff3', marginBottom: '14px' }}>
                                 <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    <button
                                       type='button'
                                       onClick={() => setFinanceActiveTab('transactions')}
                                       style={{
                                          border: 'none',
                                          borderBottom: financeActiveTab === 'transactions' ? '2px solid #d97745' : '2px solid transparent',
                                          background: 'transparent',
                                          color: financeActiveTab === 'transactions' ? '#d97745' : '#6b7280',
                                          fontWeight: 700,
                                          fontSize: '13px',
                                          padding: '10px 12px'
                                       }}
                                    >
                                       Transactions
                                    </button>
                                    <button
                                       type='button'
                                       onClick={() => setFinanceActiveTab('subsidies')}
                                       style={{
                                          border: 'none',
                                          borderBottom: financeActiveTab === 'subsidies' ? '2px solid #d97745' : '2px solid transparent',
                                          background: 'transparent',
                                          color: financeActiveTab === 'subsidies' ? '#d97745' : '#6b7280',
                                          fontWeight: 700,
                                          fontSize: '13px',
                                          padding: '10px 12px'
                                       }}
                                    >
                                       Subsidies
                                    </button>
                                 </div>
                              </div>

                              {financeActiveTab === 'transactions' ? (
                                 <>
                                    <Row className='g-2 mb-3'>
                                       <Col xs={12} sm={6} lg={3}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', background: '#fff' }}>
                                             <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Total</div>
                                             <div style={{ fontSize: '18px', color: '#1f2937', fontWeight: 700 }}>{gradeTransactionsMeta?.total || 0}</div>
                                          </div>
                                       </Col>
                                       <Col xs={12} sm={6} lg={3}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', background: '#fff' }}>
                                             <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Subsidy Amount</div>
                                             <div style={{ fontSize: '18px', color: '#1f2937', fontWeight: 700 }}>{formatCurrency(gradeTransactions.reduce((sum, item) => sum + Number(item?.subsidy_amount || 0), 0))}</div>
                                          </div>
                                       </Col>
                                       <Col xs={12} sm={6} lg={3}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', background: '#fff' }}>
                                             <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Gross Amount</div>
                                             <div style={{ fontSize: '18px', color: '#1f2937', fontWeight: 700 }}>{formatCurrency(gradeTransactions.reduce((sum, item) => sum + Number(item?.price || 0), 0))}</div>
                                          </div>
                                       </Col>
                                       <Col xs={12} sm={6} lg={3}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', background: '#fff' }}>
                                             <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Total Amount</div>
                                             <div style={{ fontSize: '18px', color: '#1f2937', fontWeight: 700 }}>{formatCurrency(gradeTransactions.reduce((sum, item) => sum + Number(item?.total_amount || 0), 0))}</div>
                                          </div>
                                       </Col>
                                    </Row>

                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                       {[{ key: 'unpaid', label: 'Unpaid' }, { key: 'paid', label: 'Paid' }, { key: 'all', label: 'All' }].map((filterType) => (
                                          <button
                                             key={filterType.key}
                                             type='button'
                                             onClick={() => handleFinanceTransactionTypeChange(filterType.key)}
                                             style={{
                                                border: financeTransactionType === filterType.key ? '1px solid #d97745' : '1px solid #e5e7eb',
                                                background: financeTransactionType === filterType.key ? '#fff7ed' : '#fff',
                                                color: financeTransactionType === filterType.key ? '#d97745' : '#6b7280',
                                                borderRadius: '16px',
                                                padding: '4px 12px',
                                                fontSize: '12px',
                                                fontWeight: 600
                                             }}
                                          >
                                             {filterType.label}
                                          </button>
                                       ))}
                                    </div>

                                    {showFinanceTransactionsLoader ? (
                                       <div style={{ textAlign: 'center', color: '#6b7280', padding: '20px' }}>
                                          <span className='spinner-border spinner-border-sm me-2'></span>
                                          Loading transactions...
                                       </div>
                                    ) : gradeTransactions?.length > 0 ? (
                                       <>
                                          <div style={{ display: isCompactViewport ? 'none' : 'block', overflowX: 'auto' }}>
                                             <table className='table table-sm align-middle mb-0'>
                                                <thead>
                                                   <tr style={{ color: '#6b7280', fontSize: '11px', textTransform: 'uppercase' }}>
                                                      <th>Date</th>
                                                      <th>Room</th>
                                                      <th>Invoice Period</th>
                                                      <th>Status</th>
                                                      <th className='text-end'>Gross</th>
                                                      <th className='text-end'>Subsidy</th>
                                                      <th className='text-end'>Total</th>
                                                      <th className='text-end'>Action</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {gradeTransactions.map((txn) => {
                                                      const statusStyle = getTransactionStatusStyle(txn?.status);
                                                      const isUnpaidTransaction = !(txn?.status === 1 || txn?.status === '1');
                                                      return (
                                                         <tr key={txn.id}>
                                                            <td style={{ fontSize: '13px', color: '#1f2937', fontWeight: 600 }}>{Moment(txn?.payment_date || txn?.created_at).format('DD MMM YY')}</td>
                                                            <td style={{ fontSize: '13px', color: '#1f2937' }}>{txn?.user_grade?.grade_name?.name || '-'}</td>
                                                            <td style={{ fontSize: '13px', color: '#4b5563' }}>{txn?.billing_start_date ? Moment(txn.billing_start_date).format('DD MMM YYYY') : '-'}</td>
                                                            <td>
                                                               <span style={{ ...statusStyle, fontSize: '11px', borderRadius: '12px', padding: '3px 10px', fontWeight: 600 }}>
                                                                  {getTransactionStatusLabel(txn?.status)}
                                                               </span>
                                                            </td>
                                                            <td className='text-end' style={{ fontSize: '13px', color: '#1f2937', fontWeight: 600 }}>{formatCurrency(txn?.price)}</td>
                                                            <td className='text-end' style={{ fontSize: '13px', color: '#16a34a', fontWeight: 600 }}>{formatCurrency(txn?.subsidy_amount)}</td>
                                                            <td className='text-end' style={{ fontSize: '13px', color: '#1f2937', fontWeight: 700 }}>{formatCurrency(txn?.total_amount)}</td>
                                                            <td className='text-end'>
                                                               {isUnpaidTransaction ? (
                                                                  <button
                                                                     type='button'
                                                                     onClick={() => openFinancePayModal(txn)}
                                                                     style={{
                                                                        border: '1px solid #d97745',
                                                                        background: '#fff7ed',
                                                                        color: '#d97745',
                                                                        borderRadius: '14px',
                                                                        padding: '4px 12px',
                                                                        fontSize: '11px',
                                                                        fontWeight: 700
                                                                     }}
                                                                  >
                                                                     Pay
                                                                  </button>
                                                               ) : (
                                                                  <span style={{ fontSize: '11px', color: '#9ca3af', fontWeight: 600 }}>-</span>
                                                               )}
                                                            </td>
                                                         </tr>
                                                      );
                                                   })}
                                                </tbody>
                                             </table>
                                          </div>

                                          <div style={{ display: isCompactViewport ? 'grid' : 'none', gap: '10px' }}>
                                             {gradeTransactions.map((txn) => {
                                                const statusStyle = getTransactionStatusStyle(txn?.status);
                                                  const isUnpaidTransaction = !(txn?.status === 1 || txn?.status === '1');
                                                return (
                                                   <div key={txn.id} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', background: '#fff' }}>
                                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '8px' }}>
                                                         <div>
                                                            <div style={{ fontSize: '13px', fontWeight: 700, color: '#1f2937' }}>{txn?.user_grade?.grade_name?.name || '-'}</div>
                                                            <div style={{ fontSize: '11px', color: '#6b7280' }}>{Moment(txn?.payment_date || txn?.created_at).format('DD MMM YYYY')}</div>
                                                         </div>
                                                         <span style={{ ...statusStyle, fontSize: '10px', borderRadius: '12px', padding: '2px 8px', fontWeight: 600 }}>
                                                            {getTransactionStatusLabel(txn?.status)}
                                                         </span>
                                                      </div>
                                                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                                                         <div style={{ fontSize: '12px', color: '#6b7280' }}>Gross: <strong style={{ color: '#1f2937' }}>{formatCurrency(txn?.price)}</strong></div>
                                                         <div style={{ fontSize: '12px', color: '#6b7280' }}>Subsidy: <strong style={{ color: '#16a34a' }}>{formatCurrency(txn?.subsidy_amount)}</strong></div>
                                                         <div style={{ fontSize: '12px', color: '#6b7280' }}>Total: <strong style={{ color: '#1f2937' }}>{formatCurrency(txn?.total_amount)}</strong></div>
                                                         <div style={{ fontSize: '12px', color: '#6b7280' }}>Txn Id: <strong style={{ color: '#1f2937' }}>{txn?.transaction_id || 'N/A'}</strong></div>
                                                      </div>
                                                      {isUnpaidTransaction ? (
                                                         <button
                                                            type='button'
                                                            onClick={() => openFinancePayModal(txn)}
                                                            style={{
                                                               border: '1px solid #d97745',
                                                               background: '#fff7ed',
                                                               color: '#d97745',
                                                               borderRadius: '14px',
                                                               padding: '5px 14px',
                                                               fontSize: '11px',
                                                               fontWeight: 700,
                                                               marginTop: '10px'
                                                            }}
                                                         >
                                                            Pay {formatCurrency(txn?.total_amount)}
                                                         </button>
                                                      ) : null}
                                                   </div>
                                                );
                                             })}
                                          </div>
                                       </>
                                    ) : (
                                       <NoDataFound txtData={'Transactions not found!'} />
                                    )}
                                 </>
                              ) : (
                                 userSubsidy ? (
                                    <Row className='g-3'>
                                       <Col md={7}>
                                          <Card style={{ border: '1px solid #e5e7eb', borderRadius: '10px', height: '100%' }}>
                                             <Card.Body>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                                   <h6 style={{ margin: 0, color: '#1f2937', fontWeight: 700 }}>Subsidy Details</h6>
                                                   <span style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '12px', background: getSubsidyStatus(userSubsidy) === 'Active' ? '#dcfce7' : getSubsidyStatus(userSubsidy) === 'Upcoming' ? '#dbeafe' : '#fee2e2', color: getSubsidyStatus(userSubsidy) === 'Active' ? '#15803d' : getSubsidyStatus(userSubsidy) === 'Upcoming' ? '#1d4ed8' : '#b91c1c', fontWeight: 700 }}>
                                                      {getSubsidyStatus(userSubsidy)}
                                                   </span>
                                                </div>
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
                                                   <div style={{ border: '1px solid #eef2f7', borderRadius: '8px', padding: '10px' }}>
                                                      <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Amount</div>
                                                      <div style={{ fontSize: '20px', color: '#16a34a', fontWeight: 700 }}>{formatCurrency(userSubsidy?.amount)}</div>
                                                   </div>
                                                   <div style={{ border: '1px solid #eef2f7', borderRadius: '8px', padding: '10px' }}>
                                                      <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Start Date</div>
                                                      <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: 600 }}>{userSubsidy?.start_date ? Moment(userSubsidy.start_date).format('DD MMM YYYY') : '-'}</div>
                                                   </div>
                                                   <div style={{ border: '1px solid #eef2f7', borderRadius: '8px', padding: '10px' }}>
                                                      <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>End Date</div>
                                                      <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: 600 }}>{userSubsidy?.end_date ? Moment(userSubsidy.end_date).format('DD MMM YYYY') : '-'}</div>
                                                   </div>
                                                </div>
                                             </Card.Body>
                                          </Card>
                                       </Col>
                                       <Col md={5}>
                                          <Card style={{ border: '1px solid #e5e7eb', borderRadius: '10px', height: '100%' }}>
                                             <Card.Body>
                                                <h6 style={{ marginBottom: '16px', color: '#1f2937', fontWeight: 700 }}>Student Billing Context</h6>
                                                <div style={{ borderBottom: '1px solid #f3f4f6', paddingBottom: '8px', marginBottom: '8px' }}>
                                                   <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Student</div>
                                                   <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: 600 }}>{displayProfile?.first_name} {displayProfile?.last_name}</div>
                                                </div>
                                                <div style={{ borderBottom: '1px solid #f3f4f6', paddingBottom: '8px', marginBottom: '8px' }}>
                                                   <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Room</div>
                                                   <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: 600 }}>{displayProfile?.user_teachers_and_room?.room?.room_name || '-'}</div>
                                                </div>
                                                <div>
                                                   <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600 }}>Session</div>
                                                   <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: 600 }}>{userSubsidy?.session_name_id || '-'}</div>
                                                </div>
                                             </Card.Body>
                                          </Card>
                                       </Col>
                                    </Row>
                                 ) : (
                                    <NoDataFound txtData={'Subsidy details not found!'} />
                                 )
                              )}
                           </Card.Body>
                        </Card>
                     </div>
                  ) : daycareActiveTab === 'Learning' ? (
                     <div style={{ padding: '16px', background: '#fafbfc' }}>
                        <div style={{
                           borderRadius: '18px',
                           padding: '18px',
                           marginBottom: '14px',
                           background: 'linear-gradient(120deg, #ffffff, #eef6ff)',
                           border: '1px solid #d9e7fb',
                           color: '#14345c',
                           boxShadow: '0 8px 22px rgba(22, 53, 96, 0.06)'
                        }}>
                           <Row className='g-3 align-items-center'>
                              <Col lg={8}>
                                 <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '6px 12px', borderRadius: '999px', background: '#edf4ff', border: '1px solid #c8dbf6', color: '#335784', fontSize: '11px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: '10px' }}>
                                    <span>Learning</span>
                                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#f7c948' }}></span>
                                    <span>Game progress</span>
                                 </div>
                                 <h4 style={{ margin: 0, fontWeight: 800, lineHeight: 1.2, color: '#163660' }}>Track how your child is learning through play</h4>
                                 <p style={{ margin: '8px 0 0 0', maxWidth: '640px', fontSize: '13px', color: '#4f6380' }}>
                                    Review completed games, recent activity, and strongest performance areas in one parent-friendly learning dashboard.
                                 </p>
                              </Col>
                              <Col lg={4}>
                                 <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '8px', flexWrap: 'wrap', marginTop: isCompactViewport ? '8px' : 0 }}>
                                    <button
                                       type='button'
                                       onClick={getLearningPlayedGames}
                                       style={{
                                          border: '1px solid #c8dbf6',
                                          background: '#edf4ff',
                                          color: '#335784',
                                          borderRadius: '999px',
                                          padding: '7px 14px',
                                          fontSize: '12px',
                                          fontWeight: 700
                                       }}
                                       disabled={showLearningLoader}
                                    >
                                       Refresh Data
                                    </button>
                                    <button
                                       type='button'
                                       onClick={() => navigate('/dashboard/app/game/game-category')}
                                       style={{
                                          border: '1px solid #f6dd9f',
                                          background: '#fff8e7',
                                          color: '#925d03',
                                          borderRadius: '999px',
                                          padding: '7px 14px',
                                          fontSize: '12px',
                                          fontWeight: 800
                                       }}
                                    >
                                       Open Games
                                    </button>
                                 </div>
                              </Col>
                           </Row>
                        </div>

                        {/* Assigned Games Section */}
                        <div style={{
                           border: '1px solid #e9f5eb',
                           borderRadius: '18px',
                           background: 'linear-gradient(120deg, #ffffff, #f0fdf4)',
                           padding: '18px',
                           marginBottom: '14px',
                        }}>
                           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '14px' }}>
                              <div>
                                 <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Assigned Games</div>
                                 <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>Games assigned by your teacher — click Play to start.</div>
                              </div>
                              <button
                                 type='button'
                                 onClick={() => { setAssignedGamesFetchAttempted(false); }}
                                 disabled={assignedGamesLoading}
                                 style={{
                                    border: '1px solid #bbf7d0',
                                    background: '#f0fdf4',
                                    color: '#15803d',
                                    borderRadius: '999px',
                                    padding: '6px 14px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    cursor: assignedGamesLoading ? 'not-allowed' : 'pointer',
                                 }}
                              >
                                 {assignedGamesLoading ? (
                                    <><span className='spinner-border spinner-border-sm me-1'></span>Loading...</>
                                 ) : 'Refresh'}
                              </button>
                           </div>

                           {assignedGamesLoading ? (
                              <div style={{ textAlign: 'center', color: '#6b7280', padding: '20px' }}>
                                 <span className='spinner-border spinner-border-sm me-2'></span>
                                 Loading assigned games...
                              </div>
                           ) : assignedGames.length > 0 ? (
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' }}>
                                 {assignedGames.map((game, idx) => (
                                    <div key={game?.id || game?.game_name_id || idx} style={{
                                       border: '1px solid #d1fae5',
                                       borderRadius: '14px',
                                       background: '#fff',
                                       padding: '14px',
                                       display: 'flex',
                                       flexDirection: 'column',
                                       gap: '8px',
                                       boxShadow: '0 4px 12px rgba(21, 128, 61, 0.06)',
                                    }}>
                                       <div style={{ fontSize: '14px', color: '#111827', fontWeight: 800, lineHeight: 1.3 }}>
                                          {game?.game_name?.name || `Game ${idx + 1}`}
                                       </div>
                                       {game?.game_name?.category?.name && (
                                          <div style={{ fontSize: '11px', color: '#6b7280' }}>{game?.game_name?.category?.name}</div>
                                       )}
                                       <button
                                          type='button'
                                          onClick={() => navigate(`/dashboard/app/game/game-category?gameNameId=${game?.game_name_id}&categoryId=${game?.game_name?.category?.id}&autoPlay=1`)}
                                          style={{
                                             marginTop: 'auto',
                                             border: 'none',
                                             background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                                             color: '#fff',
                                             borderRadius: '999px',
                                             padding: '8px 16px',
                                             fontSize: '13px',
                                             fontWeight: 800,
                                             cursor: 'pointer',
                                             display: 'flex',
                                             alignItems: 'center',
                                             justifyContent: 'center',
                                             gap: '6px',
                                          }}
                                       >
                                          <i className='ri-play-fill'></i> Play
                                       </button>
                                    </div>
                                 ))}
                              </div>
                           ) : (
                              <div style={{ textAlign: 'center', padding: '20px 0', color: '#6b7280', fontSize: '13px' }}>
                                 No games have been assigned yet.
                              </div>
                           )}
                        </div>

                              {showLearningLoader ? (
                                 <div style={{ textAlign: 'center', color: '#6b7280', padding: '20px' }}>
                                    <span className='spinner-border spinner-border-sm me-2'></span>
                                    Loading learning history...
                                 </div>
                              ) : learningGames.length > 0 ? (
                                 <>
                                    <Row className='g-3 mb-3'>
                                       {[
                                          { label: 'Games Completed', value: learningGames.length, tone: '#eff6ff', accent: '#1d4ed8', icon: 'ri-trophy-line' },
                                          { label: 'Total Completions', value: totalLearningCompletions, tone: '#ecfdf5', accent: '#15803d', icon: 'ri-checkbox-circle-line' },
                                          { label: 'Highest Score', value: highestLearningScore, tone: '#fff7ed', accent: '#c2410c', icon: 'ri-bar-chart-box-line' },
                                          { label: 'Average Score', value: averageLearningScore, tone: '#f5f3ff', accent: '#7c3aed', icon: 'ri-line-chart-line' },
                                       ].map((item) => (
                                          <Col xl={3} sm={6} key={item.label}>
                                             <div style={{ border: '1px solid #e5e7eb', borderRadius: '14px', background: '#fff', padding: '14px', height: '100%', boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)' }}>
                                                <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: item.tone, color: item.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', marginBottom: '12px' }}>
                                                   <i className={item.icon}></i>
                                                </div>
                                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{item.label}</div>
                                                <div style={{ fontSize: '24px', fontWeight: 800, color: '#111827', lineHeight: 1.15, marginTop: '6px' }}>{item.value}</div>
                                             </div>
                                          </Col>
                                       ))}
                                    </Row>

                                    <Row className='g-3 mb-3'>
                                       <Col lg={8}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '14px', background: '#fff', padding: '14px', height: '100%' }}>
                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' }}>
                                                <div>
                                                   <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Recent Learning Activity</div>
                                                   <div style={{ fontSize: '12px', color: '#6b7280' }}>Recently completed or revisited games.</div>
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: 600 }}>Attempts logged: {totalLearningAttempts}</div>
                                             </div>

                                             <div style={{ display: 'grid', gap: '10px' }}>
                                                {recentLearningGames.map((game) => (
                                                   <div key={`${game?.id || game?.name}-${game?.category}-recent`} style={{ border: '1px solid #eef2f7', borderRadius: '12px', padding: '12px', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>
                                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: '10px', flexWrap: 'wrap' }}>
                                                         <div>
                                                            <div style={{ fontSize: '14px', color: '#111827', fontWeight: 700 }}>{game?.name}</div>
                                                            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>{game?.category}</div>
                                                         </div>
                                                         <span style={{ fontSize: '11px', color: '#166534', background: '#dcfce7', borderRadius: '999px', padding: '4px 10px', fontWeight: 700 }}>
                                                            {game?.completedAttempts || 0} completions
                                                         </span>
                                                      </div>
                                                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: '8px', marginTop: '10px' }}>
                                                         <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '8px 10px' }}>
                                                            <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Best score</div>
                                                            <div style={{ fontSize: '14px', color: '#111827', fontWeight: 800 }}>{game?.bestScore || 0}</div>
                                                         </div>
                                                         <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '8px 10px' }}>
                                                            <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Attempts</div>
                                                            <div style={{ fontSize: '14px', color: '#111827', fontWeight: 800 }}>{game?.totalAttempts || 0}</div>
                                                         </div>
                                                         <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '8px 10px' }}>
                                                            <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Last played</div>
                                                            <div style={{ fontSize: '13px', color: '#111827', fontWeight: 700 }}>
                                                               {game?.lastPlayedAt && Moment(game.lastPlayedAt).isValid()
                                                                  ? Moment(game.lastPlayedAt).format('DD MMM YYYY')
                                                                  : '-'}
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                ))}
                                             </div>
                                          </div>
                                       </Col>

                                       <Col lg={4}>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '14px', background: '#fff', padding: '14px', height: '100%' }}>
                                             <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Learning Highlights</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px', marginBottom: '12px' }}>Best performance snapshot and active learning areas.</div>

                                             <div style={{ borderRadius: '14px', padding: '14px', background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)', marginBottom: '12px' }}>
                                                <div style={{ fontSize: '11px', color: '#9a3412', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Top performer</div>
                                                <div style={{ fontSize: '16px', color: '#7c2d12', fontWeight: 800, marginTop: '6px' }}>{topLearningGame?.name || 'No game available'}</div>
                                                <div style={{ fontSize: '12px', color: '#9a3412', marginTop: '4px' }}>
                                                   {topLearningGame ? `${topLearningGame.category} · Best score ${topLearningGame.bestScore || 0}` : 'Start a game to see highlighted progress.'}
                                                </div>
                                             </div>

                                             <div style={{ display: 'grid', gap: '8px' }}>
                                                {learningCategories.length > 0 ? learningCategories.map((category) => (
                                                   <div key={category.label} style={{ border: '1px solid #eef2f7', borderRadius: '12px', padding: '10px 12px' }}>
                                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                                                         <div style={{ fontSize: '13px', color: '#111827', fontWeight: 700 }}>{category.label}</div>
                                                         <span style={{ fontSize: '11px', color: '#1d4ed8', background: '#dbeafe', borderRadius: '999px', padding: '3px 8px', fontWeight: 700 }}>{category.count} games</span>
                                                      </div>
                                                      <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>{category.completions} total completions recorded</div>
                                                   </div>
                                                )) : (
                                                   <div style={{ fontSize: '12px', color: '#6b7280' }}>No category data available yet.</div>
                                                )}
                                             </div>
                                          </div>
                                       </Col>
                                    </Row>

                                    <Card style={{ border: '1px solid #e5e7eb', borderRadius: '14px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)' }}>
                                       <Card.Body style={{ padding: 0 }}>
                                          <div style={{ padding: '14px 14px 10px 14px', borderBottom: '1px solid #eef2f7', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>
                                             <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Played Games History</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>A realistic record of game practice, performance, and last activity.</div>
                                          </div>
                                          <div style={{ display: isCompactViewport ? 'none' : 'block', overflowX: 'auto', padding: '4px 12px 12px 12px' }}>
                                             <table className='table table-sm align-middle mb-0'>
                                                <thead>
                                                   <tr style={{ color: '#6b7280', fontSize: '11px', textTransform: 'uppercase' }}>
                                                      <th>Game</th>
                                                      <th>Category</th>
                                                      <th className='text-end'>Best Score</th>
                                                      <th className='text-end'>Completed</th>
                                                      <th className='text-end'>Attempts</th>
                                                      <th className='text-end'>Last Played</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {learningGames.map((game) => (
                                                      <tr key={`${game?.id || game?.name}-${game?.category}`}>
                                                         <td style={{ fontSize: '13px', color: '#1f2937', fontWeight: 700 }}>{game?.name}</td>
                                                         <td style={{ fontSize: '13px', color: '#4b5563' }}>{game?.category}</td>
                                                         <td className='text-end' style={{ fontSize: '13px', color: '#1f2937', fontWeight: 800 }}>{game?.bestScore || 0}</td>
                                                         <td className='text-end'><span style={{ fontSize: '11px', color: '#166534', background: '#dcfce7', borderRadius: '999px', padding: '4px 8px', fontWeight: 700 }}>{game?.completedAttempts || 0}</span></td>
                                                         <td className='text-end' style={{ fontSize: '13px', color: '#4b5563' }}>{game?.totalAttempts || 0}</td>
                                                         <td className='text-end' style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            {game?.lastPlayedAt && Moment(game.lastPlayedAt).isValid()
                                                               ? Moment(game.lastPlayedAt).format('DD MMM YYYY, h:mm A')
                                                               : '-'}
                                                         </td>
                                                      </tr>
                                                   ))}
                                                </tbody>
                                             </table>
                                          </div>

                                          <div style={{ display: isCompactViewport ? 'grid' : 'none', gap: '10px', padding: '12px' }}>
                                             {learningGames.map((game) => (
                                                <div key={`${game?.id || game?.name}-${game?.category}`} style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '12px', background: '#fff' }}>
                                                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: '10px', marginBottom: '8px' }}>
                                                      <div>
                                                         <div style={{ fontSize: '14px', color: '#111827', fontWeight: 800 }}>{game?.name}</div>
                                                         <div style={{ fontSize: '11px', color: '#6b7280' }}>{game?.category}</div>
                                                      </div>
                                                      <span style={{ fontSize: '11px', color: '#166534', background: '#dcfce7', borderRadius: '999px', padding: '4px 8px', fontWeight: 700 }}>
                                                         {game?.completedAttempts || 0} done
                                                      </span>
                                                   </div>
                                                   <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                                      <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '8px 10px', fontSize: '12px', color: '#6b7280' }}>Best Score: <strong style={{ color: '#111827' }}>{game?.bestScore || 0}</strong></div>
                                                      <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '8px 10px', fontSize: '12px', color: '#6b7280' }}>Attempts: <strong style={{ color: '#111827' }}>{game?.totalAttempts || 0}</strong></div>
                                                      <div style={{ gridColumn: '1 / -1', background: '#f8fafc', borderRadius: '10px', padding: '8px 10px', fontSize: '12px', color: '#6b7280' }}>
                                                         Last Played: <strong style={{ color: '#111827' }}>
                                                            {game?.lastPlayedAt && Moment(game.lastPlayedAt).isValid()
                                                               ? Moment(game.lastPlayedAt).format('DD MMM YYYY, h:mm A')
                                                               : '-'}
                                                         </strong>
                                                      </div>
                                                   </div>
                                                </div>
                                             ))}
                                          </div>
                                       </Card.Body>
                                    </Card>
                                 </>
                              ) : (
                                 <div style={{
                                    border: '1px dashed #bfdbfe',
                                    borderRadius: '18px',
                                    background: 'linear-gradient(180deg, #ffffff 0%, #eff6ff 100%)',
                                    padding: '30px 24px',
                                    textAlign: 'center'
                                 }}>
                                    <div style={{ fontSize: '34px', marginBottom: '10px' }}>🎮</div>
                                    <div style={{ fontSize: '16px', color: '#1f2937', fontWeight: 800, marginBottom: '4px' }}>
                                       No played games yet
                                    </div>
                                    <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '14px', maxWidth: '420px', marginLeft: 'auto', marginRight: 'auto' }}>
                                       Start a game to build your child&apos;s learning progress history.
                                    </div>
                                    <button
                                       type='button'
                                       onClick={() => navigate('/dashboard/app/game/game-category')}
                                       style={{
                                          border: '1px solid #1d4ed8',
                                          background: '#dbeafe',
                                          color: '#1d4ed8',
                                          borderRadius: '999px',
                                          padding: '8px 16px',
                                          fontSize: '12px',
                                          fontWeight: 800
                                       }}
                                    >
                                       Go to Games
                                    </button>
                                 </div>
                              )}
                     </div>
                  ) : daycareActiveTab === 'Attendance' ? (
                     <div style={{ padding: '16px', background: '#fff' }}>

                        {showAttendanceLoader ? (
                           <div style={{ textAlign: 'center', color: '#6b7280', padding: '20px' }}>
                              <span className='spinner-border spinner-border-sm me-2'></span>
                              Loading attendance...
                           </div>
                        ) : (
                           <>
                              <Row className='g-3 mb-3'>
                                 <Col xl={4}>
                                    <div style={{ border: '1px solid #e5e7eb', borderRadius: '14px', background: '#fff', padding: '14px', height: '100%' }}>
                                       <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Month Snapshot</div>
                                       <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px', marginBottom: '12px' }}>{attendanceMonthRangeLabel}</div>

                                       <div style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '12px', background: '#fafaf9' }}>
                                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                                             <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 700 }}>Attendance Rate</span>
                                             <span style={{ fontSize: '14px', color: '#111827', fontWeight: 800 }}>{`${formatAttendancePercentage(attendanceSummary.percentage)}%`}</span>
                                          </div>
                                          <div style={{ width: '100%', height: '8px', borderRadius: '999px', background: '#e5e7eb', overflow: 'hidden' }}>
                                             <div
                                                style={{
                                                   width: `${Math.min(Math.max(Number(attendanceSummary.percentage) || 0, 0), 100)}%`,
                                                   height: '100%',
                                                   background: 'linear-gradient(90deg, #16a34a, #5c518b)',
                                                }}
                                             ></div>
                                          </div>
                                       </div>

                                       <div style={{ marginTop: '12px', display: 'grid', gap: '8px' }}>
                                          <div style={{ border: '1px solid #dcfce7', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f0fdf4' }}>
                                             <span style={{ fontSize: '12px', color: '#166534', fontWeight: 700 }}>Present Marked Days</span>
                                             <span style={{ fontSize: '16px', color: '#14532d', fontWeight: 800 }}>{attendancePresentMarkedDays}</span>
                                          </div>
                                          <div style={{ border: '1px solid #fecaca', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fef2f2' }}>
                                             <span style={{ fontSize: '12px', color: '#b91c1c', fontWeight: 700 }}>Absent Marked Days</span>
                                             <span style={{ fontSize: '16px', color: '#7f1d1d', fontWeight: 800 }}>{attendanceAbsentMarkedDays}</span>
                                          </div>
                                          <div style={{ border: '1px solid #e5e7eb', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8fafc' }}>
                                             <span style={{ fontSize: '12px', color: '#475569', fontWeight: 700 }}>No Record Days</span>
                                             <span style={{ fontSize: '16px', color: '#0f172a', fontWeight: 800 }}>{attendanceUnmarkedDays}</span>
                                          </div>
                                       </div>

                                       <div style={{ marginTop: '12px', borderTop: '1px dashed #e5e7eb', paddingTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                          <span style={{ fontSize: '11px', color: '#6b7280' }}>Marked Days: <strong style={{ color: '#111827' }}>{attendanceRecordedDays}</strong></span>
                                          <span style={{ fontSize: '11px', color: '#6b7280' }}>Total Days In Month: <strong style={{ color: '#111827' }}>{attendanceMonthStart.daysInMonth()}</strong></span>
                                       </div>
                                    </div>
                                 </Col>

                                 <Col xl={8}>
                                    <div style={{ border: '1px solid #e5e7eb', borderRadius: '14px', background: '#fff', padding: '14px', height: '100%' }}>

                                       {/* Calendar card header: title left, month nav right */}
                                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
                                          <div>
                                             <div style={{ fontSize: '15px', color: '#111827', fontWeight: 800 }}>Month Calendar</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>{`Daily status summary for ${attendanceMonthLabel} (latest record per day).`}</div>
                                          </div>

                                          {/* Month nav pill */}
                                          <div style={{ display: 'inline-flex', alignItems: 'stretch', border: '1px solid #d6d2e8', borderRadius: '10px', background: '#fff', overflow: 'hidden', boxShadow: '0 1px 3px rgba(92,81,139,0.08)' }}>
                                             <button
                                                type='button'
                                                onClick={() => handleAttendanceMonthChange(-1)}
                                                disabled={isAttendancePrevDisabled}
                                                style={{ width: '34px', border: 'none', borderRight: '1px solid #d6d2e8', background: 'transparent', color: isAttendancePrevDisabled ? '#cbc8d9' : '#5c518b', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: isAttendancePrevDisabled ? 'not-allowed' : 'pointer', flexShrink: 0, padding: 0, outline: 'none' }}
                                             ><i className='ri-arrow-left-s-line' style={{ fontSize: '16px' }}></i></button>

                                             <div style={{ padding: '6px 16px', textAlign: 'center', minWidth: '136px' }}>
                                                <div style={{ fontSize: '13px', fontWeight: 700, color: '#5c518b', lineHeight: '1.3' }}>{attendanceMonthLabel}</div>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '1px', lineHeight: '1.3' }}>{attendanceMonthRangeLabel}</div>
                                             </div>

                                             <button
                                                type='button'
                                                onClick={() => handleAttendanceMonthChange(1)}
                                                disabled={isAttendanceNextDisabled}
                                                style={{ width: '34px', border: 'none', borderLeft: '1px solid #d6d2e8', background: 'transparent', color: isAttendanceNextDisabled ? '#cbc8d9' : '#5c518b', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: isAttendanceNextDisabled ? 'not-allowed' : 'pointer', flexShrink: 0, padding: 0, outline: 'none' }}
                                             ><i className='ri-arrow-right-s-line' style={{ fontSize: '16px' }}></i></button>
                                          </div>
                                       </div>

                                       <div style={{ border: '1px solid #e5e7eb', borderRadius: '10px', padding: '10px' }}>
                                          <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 700, textTransform: 'uppercase', marginBottom: '8px' }}>Daily Attendance Status</div>
                                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: '6px', marginBottom: '6px' }}>
                                             {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day) => (
                                                <div key={day} style={{ fontSize: '10px', color: '#6b7280', textAlign: 'center', fontWeight: 700 }}>{day}</div>
                                             ))}
                                          </div>
                                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: '6px' }}>
                                             {attendanceCalendarGridItems.map((cell) => {
                                                if (cell?.isBlank) {
                                                   return <div key={cell.key} style={{ height: '34px' }}></div>;
                                                }

                                                return (
                                                   <div
                                                      key={cell.key}
                                                      title={cell.summary ? `Status: ${cell.summary.statusText}` : 'No attendance record'}
                                                      style={{
                                                         border: `1px solid ${cell.tone.border}`,
                                                         background: cell.tone.bg,
                                                         color: cell.tone.text,
                                                         borderRadius: '8px',
                                                         height: '34px',
                                                         display: 'flex',
                                                         alignItems: 'center',
                                                         justifyContent: 'center',
                                                         fontSize: '12px',
                                                         fontWeight: 700
                                                      }}
                                                   >
                                                      {cell.dayNumber}
                                                   </div>
                                                );
                                             })}
                                          </div>
                                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '10px' }}>
                                             <span style={{ fontSize: '10px', padding: '3px 7px', borderRadius: '999px', background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }}>Present Day</span>
                                             <span style={{ fontSize: '10px', padding: '3px 7px', borderRadius: '999px', background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca' }}>Absent Day</span>
                                             <span style={{ fontSize: '10px', padding: '3px 7px', borderRadius: '999px', background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>No Record</span>
                                          </div>
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           </>
                        )}
                     </div>
                  ) : daycareActiveTab === 'Documents' ? (
                     <div style={{ padding: '16px' }}>
                        {/* Lunch Plan Waiver */}
                        {displayProfile?.lunch_plan_waiver && (
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '16px' }}>
                              <Card.Body>
                                 <h5 style={{ marginBottom: '14px' }}>
                                    <i className='ri-file-text-line me-2 text-success'></i>Lunch Plan Waiver
                                 </h5>
                                 {displayProfile.lunch_plan_waiver.reason && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                                       <strong>Reason:</strong> {displayProfile.lunch_plan_waiver.reason}
                                    </p>
                                 )}
                                 {displayProfile.lunch_plan_waiver.fillup_date && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                                       <strong>Date:</strong> {Moment(displayProfile.lunch_plan_waiver.fillup_date).format('MMM DD, YYYY')}
                                    </p>
                                 )}
                                 <Row className='g-3 mt-1'>
                                    {displayProfile.lunch_plan_waiver.parents_signature && (
                                       <Col md={6}>
                                          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Parent Signature</div>
                                             <img src={displayProfile.lunch_plan_waiver.parents_signature} alt='parent signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                                             {displayProfile.lunch_plan_waiver.parent_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>{Moment(displayProfile.lunch_plan_waiver.parent_signature_date).format('MMM DD, YYYY')}</div>
                                             )}
                                          </div>
                                       </Col>
                                    )}
                                    {displayProfile.lunch_plan_waiver.supervisor_signature && (
                                       <Col md={6}>
                                          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Supervisor Signature</div>
                                             <img src={displayProfile.lunch_plan_waiver.supervisor_signature} alt='supervisor signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                                          </div>
                                       </Col>
                                    )}
                                 </Row>
                              </Card.Body>
                           </Card>
                        )}

                        {/* Allergy Action Plan */}
                        {displayProfile?.allergy_action_plan && (
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '16px' }}>
                              <Card.Body>
                                 <h5 style={{ marginBottom: '14px' }}>
                                    <i className='ri-heart-pulse-line me-2 text-danger'></i>Allergy & Preference Action Plan
                                 </h5>
                                 <Row className='g-2 mb-3'>
                                    {[
                                       { label: 'Peanuts', value: displayProfile.allergy_action_plan.is_peanuts },
                                       { label: 'Tree Nuts', value: displayProfile.allergy_action_plan.is_tree_nuts },
                                       { label: 'Milk', value: displayProfile.allergy_action_plan.is_milk },
                                       { label: 'Shellfish', value: displayProfile.allergy_action_plan.is_shellfish },
                                       { label: 'Fish', value: displayProfile.allergy_action_plan.is_fish },
                                       { label: 'Food Additives', value: displayProfile.allergy_action_plan.is_food_additives },
                                       { label: 'All Dairy', value: displayProfile.allergy_action_plan.all_dairy_products },
                                       { label: 'Insect Stings', value: displayProfile.allergy_action_plan.insect_stings_bites },
                                    ].filter(item => item.value).map(item => (
                                       <Col xs='auto' key={item.label}>
                                          <span style={{ background: '#fee2e2', color: '#dc2626', fontSize: '12px', padding: '3px 10px', borderRadius: '20px', fontWeight: 500 }}>{item.label}</span>
                                       </Col>
                                    ))}
                                 </Row>
                                 {displayProfile.allergy_action_plan.symptoms && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                                       <strong>Symptoms:</strong> {displayProfile.allergy_action_plan.symptoms}
                                    </p>
                                 )}
                                 {displayProfile.allergy_action_plan.emergency_treatment_procedures && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                                       <strong>Emergency Treatment:</strong> {displayProfile.allergy_action_plan.emergency_treatment_procedures}
                                    </p>
                                 )}
                                 {displayProfile.allergy_action_plan.require_epi_pen === 1 && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                                       <strong>Epi-Pen Location:</strong> {displayProfile.allergy_action_plan.location_of_epi_pen}
                                    </p>
                                 )}
                                 <Row className='g-3 mt-1'>
                                    {displayProfile.allergy_action_plan.parent_signature && (
                                       <Col md={6}>
                                          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Parent Signature</div>
                                             <img src={displayProfile.allergy_action_plan.parent_signature} alt='parent signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                                             {displayProfile.allergy_action_plan.parent_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>{Moment(displayProfile.allergy_action_plan.parent_signature_date).format('MMM DD, YYYY')}</div>
                                             )}
                                          </div>
                                       </Col>
                                    )}
                                    {displayProfile.allergy_action_plan.supervisor_signature && (
                                       <Col md={6}>
                                          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Supervisor Signature</div>
                                             <img src={displayProfile.allergy_action_plan.supervisor_signature} alt='supervisor signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                                             {displayProfile.allergy_action_plan.supervisor_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>{Moment(displayProfile.allergy_action_plan.supervisor_signature_date).format('MMM DD, YYYY')}</div>
                                             )}
                                          </div>
                                       </Col>
                                    )}
                                 </Row>
                              </Card.Body>
                           </Card>
                        )}

                        {/* No Peanut Policy */}
                        {displayProfile?.no_peanut_policy && (
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '16px' }}>
                              <Card.Body>
                                 <h5 style={{ marginBottom: '14px' }}>
                                    <i className='ri-shield-check-line me-2 text-warning'></i>No Peanut Policy
                                 </h5>
                                 {displayProfile.no_peanut_policy.description && (
                                    <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                                       <strong>Description:</strong> {displayProfile.no_peanut_policy.description}
                                    </p>
                                 )}
                                 {displayProfile.no_peanut_policy.parent_signature && (
                                    <Row className='g-3 mt-1'>
                                       <Col md={6}>
                                          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                                             <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Parent Signature</div>
                                             <img src={displayProfile.no_peanut_policy.parent_signature} alt='parent signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                                             {displayProfile.no_peanut_policy.parent_signature_date && (
                                                <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>{Moment(displayProfile.no_peanut_policy.parent_signature_date).format('MMM DD, YYYY')}</div>
                                             )}
                                          </div>
                                       </Col>
                                    </Row>
                                 )}
                              </Card.Body>
                           </Card>
                        )}

                        {!displayProfile?.lunch_plan_waiver && !displayProfile?.allergy_action_plan && !displayProfile?.no_peanut_policy && (
                           <div style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>No documents on file.</div>
                        )}
                     </div>
                  ) : daycareActiveTab === 'Parent Access' ? (
                     <div style={{ padding: '16px' }}>
                        {parentAccessLoading ? (
                           <div style={{ textAlign: 'center', padding: '40px' }}>
                              <img src={loader} alt='loading' style={{ width: '40px' }} />
                           </div>
                        ) : (
                           <>
                              {/* Summary stats: how many invitations were sent, how many
                                  turned into a signed-up connection, and how many of
                                  those are currently active. */}
                              <Row className='g-3 mb-3'>
                                 <Col md={4}>
                                    <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                       <Card.Body style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                          <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-mail-send-line' style={{ color: '#0d6efd', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontSize: '20px', fontWeight: 700, color: '#1f2937' }}>{parentAccessInvitationsTotal}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Invitations Sent</div>
                                          </div>
                                       </Card.Body>
                                    </Card>
                                 </Col>
                                 <Col md={4}>
                                    <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                       <Card.Body style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                          <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-user-follow-line' style={{ color: '#16a34a', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontSize: '20px', fontWeight: 700, color: '#1f2937' }}>{parentAccessAcceptedTotal}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Signed Up &amp; Connected</div>
                                          </div>
                                       </Card.Body>
                                    </Card>
                                 </Col>
                                 <Col md={4}>
                                    <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                       <Card.Body style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                          <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#fff7ed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                             <i className='ri-shield-check-line' style={{ color: '#f59e0b', fontSize: '20px' }}></i>
                                          </div>
                                          <div>
                                             <div style={{ fontSize: '20px', fontWeight: 700, color: '#1f2937' }}>{parentAccessAcceptedList.filter((item) => item?.status === 1).length}</div>
                                             <div style={{ fontSize: '12px', color: '#6b7280' }}>Currently Active</div>
                                          </div>
                                       </Card.Body>
                                    </Card>
                                 </Col>
                              </Row>

                              {/* One combined list: every invitation sent, matched up with
                                  its connection once the parent signs up, so each parent
                                  shows up exactly once with whatever's currently true for
                                  them — pending, signed up but not yet processed, active,
                                  or deactivated — instead of two tables repeating them. */}
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                 <Card.Body>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
                                       <h6 style={{ color: '#f59e0b', fontWeight: 700, textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em', margin: 0 }}>
                                          <i className='ri-team-line me-2'></i>Parents &amp; Invitations
                                       </h6>
                                       <Button size='sm' variant='outline-primary' onClick={() => setShowInviteParentModal(true)}>
                                          <i className='ri-user-add-line me-1'></i>Invite Parent
                                       </Button>
                                    </div>
                                    {(() => {
                                       const combinedParentRows = getCombinedParentRows();
                                       return combinedParentRows.length > 0 ? (
                                          <div style={{ overflowX: 'auto' }}>
                                             <table className='table table-borderless mb-0' style={{ fontSize: '13px' }}>
                                                <thead>
                                                   <tr style={{ borderBottom: '1px solid #e5e7eb', color: '#6b7280', fontSize: '11px', textTransform: 'uppercase' }}>
                                                      <th>Parent</th>
                                                      <th>Email</th>
                                                      <th>Reference Code</th>
                                                      <th>Date</th>
                                                      <th>Status</th>
                                                      <th style={{ textAlign: 'right' }}>Access</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {combinedParentRows.map((row) => (
                                                      <tr key={row.key} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                         <td style={{ fontWeight: 600, color: '#1f2937' }}>
                                                            {row.parentName || <span style={{ color: '#9ca3af', fontWeight: 400 }}>Not signed up yet</span>}
                                                         </td>
                                                         <td style={{ color: '#374151' }}>{row.email}</td>
                                                         <td style={{ color: '#6b7280' }}>{row.refCode || '-'}</td>
                                                         <td style={{ color: '#6b7280' }}>{row.date ? Moment(row.date).format('MMM DD, YYYY') : '-'}</td>
                                                         <td>
                                                            <span style={{
                                                               fontSize: '11px', padding: '2px 8px', borderRadius: '12px', fontWeight: 600,
                                                               background: row.status === 'active' ? '#dcfce7' : row.status === 'deactivated' ? '#fee2e2' : '#fef3c7',
                                                               color: row.status === 'active' ? '#16a34a' : row.status === 'deactivated' ? '#dc2626' : '#b45309',
                                                            }}>
                                                               {row.status === 'active' ? 'Active' : row.status === 'deactivated' ? 'Deactivated' : 'Pending'}
                                                            </span>
                                                         </td>
                                                         <td style={{ textAlign: 'right' }}>
                                                            {row.accepted ? (
                                                               <Form.Check
                                                                  type='switch'
                                                                  id={`parent-access-switch-${row.accepted.id}`}
                                                                  checked={row.accepted.status === 1}
                                                                  disabled={parentAccessTogglingId === row.accepted.parent_id}
                                                                  onChange={() => toggleParentAccessStatus(row.accepted)}
                                                                  style={{ display: 'inline-block', transform: 'scale(1.2)' }}
                                                               />
                                                            ) : (
                                                               <span style={{ color: '#d1d5db', fontSize: '12px' }}>&mdash;</span>
                                                            )}
                                                         </td>
                                                      </tr>
                                                   ))}
                                                </tbody>
                                             </table>
                                          </div>
                                       ) : (
                                          <div style={{ color: '#9ca3af', fontSize: '13px' }}>No invitations sent yet.</div>
                                       );
                                    })()}
                                 </Card.Body>
                              </Card>
                           </>
                        )}
                     </div>
                  ) : (
                     <div style={{ padding: '18px', color: '#6b7280' }}>
                        {daycareActiveTab} content is being prepared in this design layout.
                     </div>
                  )}
               </Card>
            </Container>

            <Modal show={showFinancePayModal} onHide={closeFinancePayModal} centered>
               <Modal.Header closeButton={!isFinancePaymentSubmitting && !isAddCardSubmitting}>
                  <Modal.Title style={{ fontSize: '16px' }}>Pay Transaction</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  {/* Transaction summary */}
                  <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#4b5563', marginBottom: '14px' }}>
                     <div><strong>Room:</strong> {selectedFinanceTransaction?.user_grade?.grade_name?.name || '-'}</div>
                     <div><strong>Invoice Date:</strong> {selectedFinanceTransaction?.billing_start_date ? Moment(selectedFinanceTransaction.billing_start_date).format('DD MMM YYYY') : '-'}</div>
                     <div><strong>Amount Due:</strong> <strong style={{ color: '#d97745' }}>{formatCurrency(selectedFinanceTransaction?.total_amount)}</strong></div>
                  </div>

                  {/* Tab toggle */}
                  <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb', marginBottom: '16px' }}>
                     <button
                        type='button'
                        onClick={() => setFinanceModalView('pay')}
                        style={{ flex: 1, border: 'none', borderBottom: financeModalView === 'pay' ? '2px solid #d97745' : '2px solid transparent', background: 'transparent', color: financeModalView === 'pay' ? '#d97745' : '#6b7280', fontWeight: 700, fontSize: '13px', padding: '8px 0' }}
                     >
                        Pay with Saved Card
                     </button>
                     <button
                        type='button'
                        onClick={() => setFinanceModalView('add-card')}
                        style={{ flex: 1, border: 'none', borderBottom: financeModalView === 'add-card' ? '2px solid #d97745' : '2px solid transparent', background: 'transparent', color: financeModalView === 'add-card' ? '#d97745' : '#6b7280', fontWeight: 700, fontSize: '13px', padding: '8px 0' }}
                     >
                        + Add New Card
                     </button>
                  </div>

                  {financeModalView === 'pay' ? (
                     <Form.Group>
                        <Form.Label style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>Select QuickBooks Card</Form.Label>
                        {financeSavedCards.length === 0 ? (
                           <div style={{ fontSize: '13px', color: '#b91c1c', background: '#fee2e2', borderRadius: '6px', padding: '8px 12px' }}>
                              No saved cards found. Use the &ldquo;Add New Card&rdquo; tab to add one.
                           </div>
                        ) : (
                           <Form.Select
                              value={selectedFinanceCardId}
                              onChange={(event) => setSelectedFinanceCardId(event.target.value)}
                              disabled={isFinancePaymentSubmitting}
                           >
                              <option value=''>Select card</option>
                              {financeSavedCards.map((card) => (
                                 <option key={card.id} value={String(card.id)}>
                                    {card.name || card.brand || 'Card'} {card.last4 ? `ending ${card.last4}` : ''} {card.expMonth || card.expYear ? `(${card.expMonth || '--'}/${card.expYear || '--'})` : ''}
                                 </option>
                              ))}
                           </Form.Select>
                        )}
                     </Form.Group>
                  ) : (
                     <>
                        <Form.Group className='mb-2'>
                           <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>Card Holder Name</Form.Label>
                           <Form.Control
                              type='text'
                              size='sm'
                              placeholder='Full name on card'
                              value={newCardHolder}
                              onChange={(e) => setNewCardHolder(e.target.value)}
                              disabled={isAddCardSubmitting}
                           />
                        </Form.Group>
                        <Form.Group className='mb-2'>
                           <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>Card Number</Form.Label>
                           <Form.Control
                              type='text'
                              size='sm'
                              placeholder='1234 5678 9012 3456'
                              value={newCardNumber}
                              onChange={(e) => setNewCardNumber(formatFinanceCardInput(e.target.value))}
                              disabled={isAddCardSubmitting}
                           />
                        </Form.Group>
                        <Row className='g-2 mb-2'>
                           <Col xs={4}>
                              <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>Month</Form.Label>
                              <Form.Select size='sm' value={newCardExpMonth} onChange={(e) => setNewCardExpMonth(e.target.value)} disabled={isAddCardSubmitting}>
                                 {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')).map((m) => <option key={m} value={m}>{m}</option>)}
                              </Form.Select>
                           </Col>
                           <Col xs={4}>
                              <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>Year</Form.Label>
                              <Form.Select size='sm' value={newCardExpYear} onChange={(e) => setNewCardExpYear(e.target.value)} disabled={isAddCardSubmitting}>
                                 {Array.from({ length: 10 }, (_, i) => String(new Date().getFullYear() + i)).map((y) => <option key={y} value={y}>{y}</option>)}
                              </Form.Select>
                           </Col>
                           <Col xs={4}>
                              <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>CVV</Form.Label>
                              <Form.Control
                                 type='password'
                                 size='sm'
                                 placeholder='123'
                                 value={newCardCvv}
                                 onChange={(e) => setNewCardCvv(e.target.value.replace(/\D/g, '').slice(0, 4))}
                                 disabled={isAddCardSubmitting}
                              />
                           </Col>
                        </Row>
                        <Form.Group className='mb-2'>
                           <Form.Label style={{ fontSize: '12px', fontWeight: 600 }}>ZIP / Postal Code</Form.Label>
                           <Form.Control
                              type='text'
                              size='sm'
                              placeholder='ZIP'
                              value={newCardZip}
                              onChange={(e) => setNewCardZip(e.target.value)}
                              disabled={isAddCardSubmitting}
                           />
                        </Form.Group>
                        <Button
                           variant='outline-primary'
                           size='sm'
                           className='w-100 mt-1'
                           onClick={addFinanceCard}
                           disabled={isAddCardSubmitting}
                        >
                           {isAddCardSubmitting ? 'Saving card...' : 'Save Card & Continue'}
                        </Button>
                     </>
                  )}
               </Modal.Body>
               <Modal.Footer>
                  <Button variant='secondary' size='sm' onClick={closeFinancePayModal} disabled={isFinancePaymentSubmitting || isAddCardSubmitting}>Cancel</Button>
                  {financeModalView === 'pay' && (
                     <Button variant='primary' size='sm' onClick={submitFinanceTransactionPayment} disabled={isFinancePaymentSubmitting || !selectedFinanceCardId}>
                        {isFinancePaymentSubmitting ? 'Processing...' : `Pay ${formatCurrency(selectedFinanceTransaction?.total_amount)}`}
                     </Button>
                  )}
               </Modal.Footer>
            </Modal>
            <Modal show={showInviteParentModal} onHide={() => !sendingParentInvite && setShowInviteParentModal(false)} centered>
               <Modal.Header closeButton={!sendingParentInvite}>
                  <Modal.Title style={{ fontSize: '16px' }}>Send Parent Invitation</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  <Form.Group>
                     <Form.Label>Parent's Email</Form.Label>
                     <Form.Control
                        type="email"
                        placeholder="Enter parent's email address"
                        value={parentInviteEmail}
                        onChange={(e) => setParentInviteEmail(e.target.value)}
                        disabled={sendingParentInvite}
                     />
                  </Form.Group>
               </Modal.Body>
               <Modal.Footer>
                  <Button variant='secondary' size='sm' onClick={() => setShowInviteParentModal(false)} disabled={sendingParentInvite}>Cancel</Button>
                  <Button variant='primary' size='sm' onClick={sendParentInvitation} disabled={sendingParentInvite}>
                     {sendingParentInvite ? 'Sending...' : 'Send Invitation'}
                  </Button>
               </Modal.Footer>
            </Modal>
         </div>
      );
   }


}

export default UserProfile;